import { Component, Input, ViewEncapsulation, ViewChildren, QueryList, ViewChild, SecurityContext } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { element } from 'protractor';

import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
//import { ToasterModule, ToasterService, ToasterConfig } from 'angular2-toaster';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl, FormGroupName } from '@angular/forms';
import { ValidationFormsService } from './validation-forms.service';
import { ValidatorFn, ValidationErrors } from '@angular/forms';
import { ToasterComponent, ToasterPosition } from '@coreui/angular';
import { AppToastComponent as ToastComp } from '../../../services/shared-service/toast-simple/toast.component'
import { HttpService } from '../../../services/http-service/http.service'
import { ModalDirective } from 'ngx-bootstrap/modal';

import { LocalInterfaceService } from '../../../services/local-inteface-service/local-interface.service';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from '../../../services/storege-service/storage.service';
import { ValidationService } from '../../../services/validation-service/validation.service';
import * as moment from 'moment';
import { environment } from '../../../../environments/environment';
import { NgxTippyService } from 'ngx-tippy-wrapper';
import { DomSanitizer } from '@angular/platform-browser';
import { ToolService } from '../../../services/tool/tool.service';

@Component({
  //selector: 'app-toasters',
  templateUrl: 'basic-forms.component.html',
  styleUrls: ["../../../../../node_modules/ngx-bootstrap/datepicker/bs-datepicker.css",],
  encapsulation: ViewEncapsulation.None,
  providers: [ValidationFormsService]
})


export class BasicFormsComponent {


  minDate = new Date(2017, 5, 10);
  maxDate = new Date(2022, 9, 15);

  bsValue: Date = new Date();

  // Timepicker

  public isEnabled: boolean = true;


  public mfData?: object = {};
  public trnData?;
  public resData?: object = {};
  public courts?;
  public bookingCategories?;
  public coaches?;
  public users?;
  public paymentMethods?;
  public teams?;
  public timingSlots?;
  public dbMatchResultsData?;
  public dbMatchResultsTeamAData? = Array();
  public dbMatchResultsTeamBData? = Array();
  public dbClassResultsData?;
  isUpdate: boolean = false;
  dbFunction?: string;
  relatedIds: string;
  memberId: string;
  customerName: string;
  customerMobile: string;
  customerCountryCode: string;
  startTime;
  //endTime;
  endTiming: number;
  subTotalPrice: string;
  addon: string;
  bookingAddon: string;
  tax: string;
  totalPrice: string;
  paidAmount: string;
  ccy: string;
  paymentStatus: string;
  notes: string;
  paidDate: Date;
  isReoccur: string;
  noShow: string;
  cancelled: string;
  cancelledDate: Date;
  imageUrl: string;
  brouchureUrl: string;
  uploadedImage: File;
  uploadedBrochure: File;
  court?: string;
  bookingCategoryId?: string;
  coachId?: string;
  userId?: string;
  bookingId: string;
  channel?: string;
  facilityId: string;
  paidOfflineAmount: string;
  public bookingAddonsArray?: Array<{ id: number, name: String, count: number, price: number }> = [];
  public bookingAddons?;
  public bookingAddonInstances?;
  pendingPayment = '0';

  public bookingReOccur: boolean = false;
  public bookingReOccurDays;
  public bookingReOccurInstance;
  public bookingTotalWithReoocur;
  public courtPrice;
  public selectedReoccurDay;

  public bookingDate;

  public courtPrice30min = 0.0;
  public courtPrice60min = 0.0;
  public courtPrice90min = 0.0;
  public courtPrice120min = 0.0;
  public courtOfferPrice30min = 0.0;
  public courtOfferPrice60min = 0.0;
  public courtOfferPrice90min = 0.0;
  public courtOfferPrice120min = 0.0;
  public taxPercentage = 0;
  public existingBookingAddonArray;
  paymentMethod?: string;
  userType?: string;
  public selectedPaymentMethod;
  public selectedPlayer;
  isAddonBtn: boolean = false;
  isError: boolean = false;
  formChanged: boolean = false;
  public selectedId?;
  totalRemainingAmount = 0.0;
  isFromCalendar: boolean = false;
  simpleForm: FormGroup;
  submitted = false;
  formErrors: any;
  public isLoading: boolean = true;
  public isFirstEnter: boolean = false;
  totalDiscount = 0;
  public showPaymentPending = '0';
  public facilityCountryCode = 'BHD';

  public responseData?;
  public dbActiveData? = Array();
  public membershipDescription: string;
  public membershipName: string;

  matchId: string;
  facilityName: string;
  courtName: string;
  matchType: string;
  matchNoOfSets: string;
  matchCategory: string;
  matchAccess: string;
  matchNotes: string;
  playerName: string;
  teamName: string;
  set1A: string;
  set2A: string;
  set3A: string;
  resultSet1A: string;
  resultSet2A: string;
  resultSet3A: string;
  resultSet1B: string;
  resultSet2B: string;
  resultSet3B: string;
  player1ACountryCode: string;
  player1AMobile: string;
  player2ACountryCode: string;
  player2AMobile: string;
  player1BCountryCode: string;
  player1BMobile: string;
  player2BCountryCode: string;
  player2BMobile: string;
  isPrivateMatch: boolean = false;
  requestToJoin: boolean = false;
  isPlayer2AGuest: boolean = false;
  isPlayer1BGuest: boolean = false;
  isPlayer2BGuest: boolean = false;
  staffId: string;
  otpNumber: string;
  sharedWallet = 'N';
  classId: string;
  noOfPlayers: string;
  classPrice: string;
  classCcy: string;
  classPlayerCountryCode: string;
  classPlayerMobile: string;
  classPlayerPaymentMethod: string;
  showInApp: string;
  name: string;
  descriptionEn: string;
  descriptionAr: string;
  matchPaidAmount: string;
  matchPlayerCountryCode: string;
  matchPlayerMobile: string;
  matchPlayerPaymentMethod: string;
  matchPlayerTeam: string;

  @ViewChild(ToastComp) toastComp: ToastComp;
  @ViewChild('dangerModal', { static: false }) public dangerModal: ModalDirective;
  @ViewChild('cancelBookingModal', { static: false }) public cancelBookingModal: ModalDirective;
  @ViewChild('noShowBookingModal', { static: false }) public noShowBookingModal: ModalDirective;
  @ViewChild('addNewPaymentModal', { static: false }) public addNewPaymentModal: ModalDirective;
  @ViewChild('refundPaymentModal', { static: false }) public refundPaymentModal: ModalDirective;
  @ViewChild('createMatchModal', { static: false }) public createMatchModal: ModalDirective;
  @ViewChild('cancelMatchModal', { static: false }) public cancelMatchModal: ModalDirective;
  @ViewChild('confirmModal', { static: false }) public confirmModal: ModalDirective;
  @ViewChild('verifyOTPModal', { static: false }) public verifyOTPModal: ModalDirective;
  @ViewChild('createClassModal', { static: false }) public createClassModal: ModalDirective;
  @ViewChild('cancelClassModal', { static: false }) public cancelClassModal: ModalDirective;
  @ViewChild('addClassPlayerModal', { static: false }) public addClassPlayerModal: ModalDirective;
  @ViewChild('removeClassPlayerModal', { static: false }) public removeClassPlayerModal: ModalDirective;
  @ViewChild('refundClassPaymentModal', { static: false }) public refundClassPaymentModal: ModalDirective;
  @ViewChild('removeMatchPlayerModal', { static: false }) public removeMatchPlayerModal: ModalDirective;
  @ViewChild('addMatchPlayerModal', { static: false }) public addMatchPlayerModal: ModalDirective;

  public paddingStyle: Object = { 'padding-right': '20px' };
  public initialValue?;

  constructor(
    private router: Router,
    private http: HttpClient,
    public route: ActivatedRoute,
    private fb: FormBuilder,
    public vf: ValidationFormsService,
    public httpService: HttpService,
    private localInterfaceSrv: LocalInterfaceService,
    private toastr: ToastrService,
    private storageSrv: StorageService,
    private validationSrv: ValidationService,
    private sanitizer: DomSanitizer,
    private tippyService: NgxTippyService,
    public toolService: ToolService,
  ) {
    //if (localStorage.getItem('currentUser') === null) {this.router.navigateByUrl('/login');}
    if (localStorage.getItem('lang') === "ar") {
      //this.toasterconfig = new ToasterConfig({tapToDismiss: true, timeout: 5000, positionClass: 'toast-top-left'});
    }
    //this.toasterService = toasterService;
    this.formErrors = this.vf.errorMessages;
    this.userType = this.storageSrv.getType();
    this.staffId = this.storageSrv.getUser();
    this.facilityId = this.storageSrv.getFacilityId();
    this.showPaymentPending = this.storageSrv.getPendingPayment();
    this.facilityCountryCode = this.storageSrv.getFacilityCountryCode();
    this.sharedWallet = this.storageSrv.getSharedWallet();
    const bookingIdFromParams = this.router.getCurrentNavigation().extras.state?.bookingId ? this.router.getCurrentNavigation().extras.state?.bookingId : this.route.snapshot.params['id'];


    if (bookingIdFromParams != undefined) {
      this.isUpdate = true;
      this.dbFunction = 'updateBookingTable';
      var calBookingId = bookingIdFromParams;
      this.route.queryParams.subscribe(async params => {
        this.simpleForm = this.fb.group({});
        this.isFromCalendar = true;
        await this.loadBookingsById(calBookingId);
        await this.loadMatchPlayers();
        await this.loadClassPlayers(this.classId);
        this.mfData = this.resData;
      });


      this.bookingId = this.mfData['id'];
      this.relatedIds = this.mfData['relatedIds'];
      this.court = this.mfData['courtId'];
      this.memberId = this.mfData['memberId'];
      this.showInApp = this.mfData['showInApp'];
      this.name = this.mfData['name'];
      this.classId = this.mfData['classId'];
      this.bookingCategoryId = this.mfData['bookingCategoryId'];
      this.coachId = this.mfData['coachId'];
      this.channel = this.mfData['channel'];
      this.customerName = this.mfData['customerName'];
      this.customerMobile = this.mfData['customerMobile'];
      this.customerCountryCode = this.mfData['customerCountryCode'];
      this.startTime = this.mfData['startTime'] != null ? new Date(this.mfData['startTime'].replace(/-/g, "/")) : this.mfData['startTime'];

      //Set end time duration
      if (!this.isFromCalendar) {
        var endTime = this.mfData['endTime'] != null ? new Date(this.mfData['endTime'].replace(/-/g, "/")) : this.mfData['endTime'];
        const duration = (endTime.getTime() - this.startTime.getTime()) / 60000;
        endTime.setMinutes(endTime.getMinutes() + Number(duration));
        this.endTiming = duration
      }

      this.subTotalPrice = this.mfData['subTotalPrice'];
      this.bookingAddon = this.mfData['addOn'] == null ? '0' : this.mfData['addOn'];
      this.tax = this.mfData['taxPrice'];
      this.totalDiscount = this.mfData['totalDiscount'] == null ? 0 : this.mfData['totalDiscount'];
      this.totalPrice = this.mfData['totalPrice'] == null ? '0' : this.mfData['totalPrice'];
      this.paidAmount = this.mfData['paidAmount'] == null ? '0' : this.mfData['paidAmount'];
      this.ccy = this.storageSrv.getFacilityCcy();
      this.classCcy = this.ccy;
      this.classPlayerCountryCode = this.facilityCountryCode;
      this.notes = this.mfData['notes'] != null ? this.mfData['notes'] : '';
      // this.paymentMethod = this.mfData['paymentMethod'] == null ? null : this.mfData['paymentMethod'];
      this.paymentMethod = null;
      this.taxPercentage = this.mfData['taxPercentage'] / 100;
      this.paymentStatus = this.mfData['paymentStatus'];
      this.paidDate = this.mfData['paidDate'] != null ? new Date(this.mfData['paidDate'].replace(/-/g, "/")) : this.mfData['paidDate'];
      this.isReoccur = this.mfData['isReoccur'];
      this.cancelled = this.mfData['cancelled'];
      this.noShow = this.mfData['noShow'];
      this.cancelledDate = this.mfData['cancelledDate'] == null ? null : new Date(this.mfData['cancelledDate'].replace(/-/g, "/"));
      this.bookingDate = this.mfData['startTime'] != null ? new Date(this.mfData['startTime'].replace(/-/g, "/")) : this.mfData['startTime'];
      this.bookingAddonsArray = this.resData["addons"] != null ? this.resData["addons"] : this.mfData["addons"];
      this.existingBookingAddonArray = this.bookingAddonsArray != null ? [...this.bookingAddonsArray] : [];
      this.trnData = this.mfData["transactions"];
      this.paidOfflineAmount = '';
      this.totalRemainingAmount = this.roundTo(parseFloat(this.totalPrice) - parseFloat(this.paidAmount), 3);
      this.matchId = this.mfData['matchId'];
      this.matchType = this.mfData['matchType'];
      this.matchCategory = this.mfData['matchCategory'];
      this.matchAccess = this.mfData['matchAccess'];
      this.matchNoOfSets = this.mfData['matchNoOfSets'];
      this.matchNotes = this.mfData['matchNotes'];
      this.membershipName = this.mfData['membershipName'];
      this.membershipDescription = this.mfData['membershipDescription'];
      this.noOfPlayers = this.mfData['noOfPlayers'];
      this.classPrice = this.mfData['classPrice'];
      this.descriptionEn = this.mfData['descriptionEn'];
      this.descriptionAr = this.mfData['descriptionAr'];
      this.matchPlayerCountryCode = this.mfData['matchPlayerCountryCode'];
      this.matchPlayerMobile = this.mfData['matchPlayerMobile'];
      this.matchPlayerPaymentMethod = this.mfData['matchPlayerPaymentMethod'];
      this.matchPlayerTeam = this.mfData['matchPlayerTeam'];
    }
    else {
      this.bookingId = '';
      this.relatedIds = '';
      this.memberId = '';
      this.classId = '';
      this.bookingCategoryId = '';
      this.coachId = '';
      this.dbFunction = '/addBooking';
      this.court = this.court == null ? null : this.court;
      this.channel = null;
      this.customerName = '';
      this.customerMobile = '';
      this.customerCountryCode = this.storageSrv.getFacilityCountryCode();
      this.classPlayerCountryCode = this.facilityCountryCode;
      this.startTime = '';
      this.endTiming = this.endTiming == null ? null : this.endTiming;;
      this.subTotalPrice = '';
      this.addon = '';
      this.tax = '';
      this.notes = '';
      this.totalDiscount = 0;
      this.totalPrice = '';
      this.paidAmount = '';
      this.ccy = this.storageSrv.getFacilityCcy();
      this.classCcy = this.storageSrv.getFacilityCcy();
      this.paymentStatus = '';
      this.paidDate = null;
      this.isReoccur = '0';
      this.noShow = '0';
      this.cancelled = '0';
      this.paymentMethod = null;
      this.cancelledDate = new Date();
      this.bookingDate = new Date();
      this.bookingAddon = '0';
      this.bookingAddonsArray = [];
      this.existingBookingAddonArray = [];
      this.paidOfflineAmount = '';
      this.matchId = '';
      this.matchType = '';
      this.matchCategory = '';
      this.matchAccess = '';
      this.matchNoOfSets = '';
      this.matchNotes = '';
      this.showInApp = '';
      this.name = '';
      this.matchPlayerCountryCode = '';
      this.matchPlayerMobile = '';
      this.matchPlayerPaymentMethod = '';
      this.matchPlayerTeam = '';
    }
    this.simpleForm = this.fb.group({});
  }

  ngOnInit(): void {
    this.validationSrv.validateAcess()
      .then(async () => {
        this.isLoading = true;
        this.route.queryParams.subscribe(async params => {
          this.facilityId = this.storageSrv.getFacilityId();
          this.showPaymentPending = this.storageSrv.getPendingPayment();
          await this.loadCourts(this.facilityId);
          await this.loadBookingCategory(this.facilityId);
          await this.loadCoaches();
          //await this.getUsers();
          await this.updateCourtId(this.court);
          await this.loadAddons(this.facilityId);
          await this.loadPaymentMethods(this.facilityId);
          await this.loadTimingSlots(this.facilityId);
          // await this.loadMatchPlayers();
          // await this.loadClassPlayers(this.classId);
          await this.loadBookingStatus();
          await this.loadTeams();
          await this.createForm();
          this.initialValue = this.simpleForm?.value;
          this.simpleForm.valueChanges.subscribe(value => {
            this.formChanged = Object.keys(this.initialValue).some(key => this.simpleForm.value[key] !=
              this.initialValue[key])
          });
          if (this.simpleForm && this.channel == 'online') {
            this.f['customerName'].disable();
            this.f['customerMobile'].disable();
            this.f['customerCountryCode'].disable();
          }
        });
      });
  }

  onSuccess(): void {
    this.validationSrv.validateAcess()
      .then(async () => {
        this.isLoading = true;
        this.route.queryParams.subscribe(async params => {
          this.facilityId = this.storageSrv.getFacilityId();
          this.showPaymentPending = this.storageSrv.getPendingPayment();
          await this.loadCourts(this.facilityId);
          await this.loadBookingCategory(this.facilityId);
          await this.loadCoaches();
          await this.updateCourtId(this.court);
          await this.loadAddons(this.facilityId);
          await this.loadPaymentMethods(this.facilityId);
          await this.loadBookingsById(this.bookingId);
          await this.loadMatchPlayers();
          await this.loadClassPlayers(this.classId);
          await this.loadBookingStatus();
          await this.loadTeams();
          await this.createForm();
          this.initialValue = this.simpleForm?.value;
          this.simpleForm.valueChanges.subscribe(value => {
            this.formChanged = Object.keys(this.initialValue).some(key => this.simpleForm.value[key] !=
              this.initialValue[key])
          });
          if (this.simpleForm && this.channel == 'online') {
            this.f['customerName'].disable();
            this.f['customerMobile'].disable();
            this.f['customerCountryCode'].disable();
          }
        });
      });
  }

  isCollapsed: boolean = false;
  iconCollapse: string = 'icon-arrow-up';

  @Input() message: string;
  messages: string[] = [];
  updatedData = this.mfData;

  createForm() {
    this.simpleForm = this.fb.group({
      bookingId: { value: this.bookingId, disabled: true },
      relatedIds: { value: this.relatedIds, disabled: true },
      court: [this.court, [Validators.required]],
      bookingCategoryId: [this.bookingCategoryId],
      coachId: [this.coachId],
      showInApp: [this.showInApp],
      name: [this.name],
      //user: [this.user, [Validators.required]],
      addon: [this.addon],
      paymentMethod: [this.paymentMethod,],
      classPlayerPaymentMethod: [this.classPlayerPaymentMethod,],
      paidOfflineAmount: [this.paidOfflineAmount],
      totalRemainingAmount: { value: this.totalRemainingAmount, disabled: true },
      customerName: [this.customerName, [Validators.required]],
      customerMobile: [this.customerMobile, [Validators.required]],
      customerCountryCode: [this.customerCountryCode, [Validators.required]],
      startTime: [this.startTime],
      endTiming: [this.endTiming],
      bookingDate: [this.bookingDate, [Validators.required]],
      subTotalPrice: { value: this.subTotalPrice, disabled: false },
      bookingAddon: { value: this.bookingAddon, disabled: true },
      tax: { value: this.tax, disabled: true },
      totalDiscount: [this.totalDiscount],
      totalPrice: { value: this.totalPrice, disabled: true },
      paidAmount: { value: this.paidAmount, disabled: true },
      ccy: { value: this.ccy, disabled: true },
      paymentStatus: { value: this.paymentStatus, disabled: true },
      paidDate: { value: this.paidDate, disabled: true },
      isReoccur: [this.isReoccur],
      notes: [this.notes],
      noShow: [this.noShow],
      cancelled: [this.cancelled],
      cancelledDate: { value: this.cancelledDate, disabled: true },
      //bookingAddon: {value: this.bookingAddon},
      bookingAddonInstances: { value: this.bookingAddonInstances, disabled: true },
      bookingReOccur: { value: this.bookingReOccur },
      bookingReOccurDays: { value: this.bookingReOccurDays, disabled: true },
      bookingReOccurInstance: { value: this.bookingReOccurInstance, disabled: true },
      bookingTotalWithReoocur: { value: this.bookingTotalWithReoocur, disabled: true },
      matchType: [this.matchType],
      matchCategory: [this.matchCategory],
      matchAccess: [this.matchAccess],
      matchNoOfSets: [this.matchNoOfSets],
      matchNotes: [this.matchNotes],
      classCcy: { value: this.classCcy, disabled: true },
      classId: [this.classId],
      classPrice: [this.classPrice],
      noOfPlayers: [this.noOfPlayers],
      classPlayerCountryCode: [this.classPlayerCountryCode],
      classPlayerMobile: [this.classPlayerMobile],
      matchPlayerCountryCode: [this.matchPlayerCountryCode],
      matchPlayerMobile: [this.matchPlayerMobile],
      matchPlayerPaymentMethod: [this.matchPlayerPaymentMethod],
      matchPlayerTeam: [this.matchPlayerTeam],
      resultSet1A: [null],
      resultSet2A: [null],
      resultSet3A: [null],
      resultSet1B: [null],
      resultSet2B: [null],
      resultSet3B: [null],
      player1ACountryCode: [this.storageSrv.getFacilityCountryCode()],
      player1AMobile: [null],
      player2ACountryCode: [this.storageSrv.getFacilityCountryCode()],
      player2AMobile: [null],
      player1BCountryCode: [this.storageSrv.getFacilityCountryCode()],
      player1BMobile: [null],
      player2BCountryCode: [this.storageSrv.getFacilityCountryCode()],
      player2BMobile: [null],
      player2ACB: [null],
      player1BCB: [null],
      player2BCB: [null],
      radioC: [null],
      selectMatchCategory: [null],
      selectedPlayer: [this.selectedPlayer],
    }, {});
  }
  get f() {
    return this.simpleForm.controls;
  }
  async showSuccess(msg) {

    await this.toastr.success(msg, 'Success');

    if (this.isUpdate && !this.isError) {
      this.onSuccess();
      //this.simpleForm.patchValue({endTiming: this.endTiming});
      // this.delay(2000).then(any=>{
      //   this.router.navigate(['../'], {relativeTo: this.route}).then(() => {
      //     //window.location.reload();
      //   });;
      // });
    }
    else if (!this.isUpdate && this.isError == false) {
      // this.delay(2000).then(any=>{
      //   this.router.navigate(['../'], {relativeTo: this.route}).then(() => {
      //     //window.location.reload();
      //   });;
      // });
    }
  }
  showError(msg) {
    //this.toasterService.pop('error', 'Error', msg);
  }
  uploadFile(event) {
    let files = event.target.files;
    const reader = new FileReader();
    if (files.length > 0) {
      this.uploadedImage = files[0]; // You will see the file
      reader.readAsDataURL(this.uploadedImage);
      reader.onload = (_event) => {
        this.imageUrl = reader.result.toString().replace('../padel/', '');
      }
    }

  }
  uploadFileBrochure(event) {
    let files = event.target.files;
    const reader = new FileReader();
    if (files.length > 0) {
      this.uploadedBrochure = files[0]; // You will see the file
      reader.readAsDataURL(this.uploadedBrochure);
      reader.onload = (_event) => {
        this.brouchureUrl = reader.result.toString().replace('../padel/', '');
      }
    }

  }
  public showPayment() {
    //this.router.navigate(['facility'], {state: {data: ''}, relativeTo: this.route});
    // if (this.editFlag == true)
    // {
    //   this.editFlag = false;
    // }
    // if (this.editFlag == false)
    // {
    //   this.editFlag = true;
    // }
    // this.myDivRef.nativeElement.scrollIntoView({behavior: "smooth", block: "start" });
  }
  public findInvalidControls() {
    const invalid = [];
    const controls = this.simpleForm.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }
  onCreateGroupFormValueChange() {
    this.simpleForm.valueChanges.subscribe(value => {
      this.formChanged = Object.keys(this.initialValue).some(key => this.simpleForm.value[key] !=
        this.initialValue[key])
    });
  }
  updateSelectedPayment(value) {
    this.selectedPaymentMethod = value;
  }

  updateSelectedPlayer(value) {
    this.selectedPlayer = value;
  }

  updateSelectedPaymentPlayer(value) {
    this.classPlayerPaymentMethod = value;
  }
  updateSelectedMatchPaymentPlayer(value) {
    this.matchPlayerPaymentMethod = value;
  }
  updateSelectedTeam(value) {
    this.matchPlayerTeam = value;
  }
  public updateBooking() {
    this.onCreateGroupFormValueChange();

    var totalPaymentPrice = 0.0;
    var fd = new FormData();
    // stop here if form is invalid
    if (this.simpleForm.invalid) {
      var msg = "";
      if (this.simpleForm.controls['customerName'].invalid) {
        msg = "booking name is not valid."
      }
      else if (this.simpleForm.controls['customerMobile'].invalid) {
        msg = "booking mobile is not valid."
      }
      else if (this.simpleForm.controls['bookingDate'].invalid) {
        msg = "booking date not valid"
      }
      else if (this.simpleForm.controls['startTime'].invalid) {
        msg = "Invalid Booking Start Time"
      }
      // else if (this.simpleForm.controls['endTime'].invalid)
      // {
      //   msg = "Invalid bookingEndTime"
      // }
      else {
        msg = 'An error has occured, please check missing fields and try again';
      }
      this.toastr.warning(msg, "Warning");
      this.toastr.warning("Check Invalid Fields: " + this.findInvalidControls(), "Warning");
      //this.showError("Check Invalid Fields: " + this.findInvalidControls());
      return;
    }

    var bookingAddons;
    var newAddons;
    var addonsUpdated = false;

    if (this.bookingAddonsArray.length != this.existingBookingAddonArray.length) {
      addonsUpdated = true;
    }

    bookingAddons = this.bookingAddonsArray;

    if (!this.simpleForm.dirty && !this.formChanged) {
      msg = "No changes made to be saved";
      this.toastr.warning(msg, "Warning");
      return;
    }

    bookingAddons = JSON.stringify(bookingAddons)

    //this.existingBookingAddonArray = this.bookingAddonsArray;

    // TODO: Use EventEmitter with form value
    this.court = this.f['court'].value
    this.bookingCategoryId = this.f['bookingCategoryId'].value
    this.coachId = this.f['coachId'].value
    this.customerName = this.f['customerName'].value
    this.customerMobile = this.f['customerMobile'].value
    this.customerCountryCode = this.f['customerCountryCode'].value
    this.notes = this.f['notes'].value
    this.bookingDate = this.f['bookingDate'].value
    this.startTime = this.f['startTime'].value
    this.endTiming = this.f['endTiming'].value
    this.showInApp = this.f['showInApp'].value

    if (this.isUpdate) {
      this.subTotalPrice = this.f['subTotalPrice'].value
      this.bookingAddon = this.f['bookingAddon'].value
      this.tax = this.f['tax'].value
      this.totalPrice = this.f['totalPrice'].value
      totalPaymentPrice = parseFloat(this.totalPrice) - parseFloat(this.f['totalPrice'].value);
    }
    else {
      this.subTotalPrice = this.f['subTotalPrice'].value
      this.bookingAddon = this.f['bookingAddon'].value
      this.tax = this.f['tax'].value
      this.totalPrice = this.f['totalPrice'].value
    }
    this.bookingReOccurDays = this.f['bookingReOccurDays'].value
    this.bookingReOccurInstance = this.f['bookingReOccurInstance'].value
    this.bookingTotalWithReoocur = this.f['bookingTotalWithReoocur'].value
    this.totalRemainingAmount = this.f['totalRemainingAmount'].value
    this.totalDiscount = this.f['totalDiscount'].value

    let formattedDate = (moment(new Date(this.f['bookingDate'].value))).format('YYYY-MM-DD')


    let startTimeDT = new Date(this.startTime);
    let endTimeDT = new Date(this.startTime);
    let endTiming = this.f['endTiming'].value
    endTimeDT.setMinutes(endTimeDT.getMinutes() + Number(endTiming));

    let formattedStartTime = startTimeDT.toTimeString().toString().substr(0, 8);
    let formattedEndTime = endTimeDT.toTimeString().toString().substr(0, 8);

    if (endTimeDT < startTimeDT) {
      endTimeDT.setDate(endTimeDT.getDate() + 1);
    }

    const duration = this.roundTo((endTimeDT.getTime() - startTimeDT.getTime()) / 60000, 0);

    var mobileCheck = /^\d+$/.test(this.customerMobile);

    if (duration == 0) {
      this.toastr.error('Booking start/end time cannot be on same time', "Error");
      return;
    }
    else if (duration < 0) {
      this.toastr.error('Booking end time cannot be before start time', "Error");
      return;
    }
    else if (this.customerMobile.length < 8) {
      this.toastr.error('Mobile Number is below valid length', "Error");
      return;
    }
    else if (!mobileCheck) {
      this.toastr.error('Mobile Number is invalid', "Error");
      return;
    }

    var startDate = formattedDate + ' ' + formattedStartTime;
    var endTime = formattedDate + ' ' + formattedEndTime;

    var dbFunction = '';
    if (this.isUpdate && !this.isReoccur) {
      dbFunction = 'updateBookingCalendar';
      fd.append('bookingId', this.bookingId);
    }
    else if (this.isUpdate && this.isReoccur) {
      dbFunction = 'updateBookingCalendar';
      fd.append('bookingReOccurInstance', this.bookingReOccurInstance);
      fd.append('bookingTotalWithReoocur', this.bookingTotalWithReoocur);
      fd.append('bookingReoccurStartTime', formattedStartTime);
      fd.append('bookingReoccurEndTime', formattedEndTime);
      fd.append('bookingId', this.bookingId);
    }
    else if (!this.isUpdate && this.isReoccur) {
      dbFunction = 'addBookingCalendar';
      fd.append('channel', 'backoffice');
      fd.append('bookingReOccurInstance', this.bookingReOccurInstance);
      fd.append('bookingTotalWithReoocur', this.bookingTotalWithReoocur);
      fd.append('bookingReoccurStartTime', formattedStartTime);
      fd.append('bookingReoccurEndTime', formattedEndTime);
    }
    else if (!this.isUpdate) {
      dbFunction = 'addBookingCalendar';
      fd.append('channel', 'backoffice');
    }

    fd.append('staffId', this.storageSrv.getUser());
    fd.append('facilityId', this.facilityId);
    fd.append('courtId', this.court);
    fd.append('bookingCategoryId', this.bookingCategoryId);
    fd.append('coachId', this.coachId);
    fd.append('paymentMethodCode', this.selectedPaymentMethod);
    fd.append('selectedPlayer', this.selectedPlayer);
    fd.append('bookingName', this.customerName);
    fd.append('bookingMobile', this.customerMobile);
    fd.append('bookingCountryCode', this.customerCountryCode);
    fd.append('bookingDate', formattedDate);
    fd.append('bookingStartTime', startDate);
    fd.append('bookingEndTime', endTime);
    fd.append('bookingDuration', duration.toString());
    fd.append('bookingPrice', this.subTotalPrice);
    fd.append('bookingAddon', this.bookingAddon);
    fd.append('bookingVAT', this.tax);
    fd.append('bookingTotal', this.totalPrice);
    fd.append('bookingTotalPayment', this.roundTo(totalPaymentPrice, 3).toString());
    fd.append('notes', this.notes);
    fd.append('isReoccur', String(this.isReoccur));
    fd.append('ccy', this.ccy);
    fd.append('taxPercentage', String(this.taxPercentage * 100));
    fd.append('bookingAddonArray', bookingAddons);
    fd.append('totalRemainingAmount', this.totalRemainingAmount.toString());
    fd.append('totalDiscount', this.totalDiscount.toString());
    fd.append('showInApp', this.showInApp);

    if (!environment.production) {
      this.toolService.showConsoleLog('date: ' + formattedDate);
      this.toolService.showConsoleLog('startDate: ' + startDate);
      this.toolService.showConsoleLog('endTime: ' + endTime);
      this.toolService.showConsoleLog('bookingPrice: ' + this.subTotalPrice);
      this.toolService.showConsoleLog('bookingAddon: ' + this.bookingAddon);
      this.toolService.showConsoleLog('bookingVAT: ' + this.tax);
      this.toolService.showConsoleLog('bookingTotal: ' + this.totalPrice);
      this.toolService.showConsoleLog('isReoccur: ' + String(this.isReoccur));
    }

    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    this.httpService.post(dbFunction, fd, '')
      .then(
        data => {
          if (this.isUpdate) {
            this.simpleForm.markAsPristine();
            this.totalDiscount = this.resData['totalDiscount'];
            this.simpleForm.patchValue({ totalDiscount: this.f['totalDiscount'].value });
            this.showSuccess('Booking updated');
            this.handleNavigationAfterBookingSaved();
          }
          else {
            this.simpleForm.markAsPristine();
            this.addNewPaymentModal.show();
            this.simpleForm.patchValue({ paidOfflineAmount: this.totalPrice });
            //this.simpleForm.patchValue({totalDiscount: this.totalDiscount});
            this.bookingId = data?.content;
            this.isUpdate = true;

            const newUrl = `${window.location.href}/${data?.content || ""}`;
            window.history.pushState({}, '', newUrl)
            this.showSuccess('Booking added');
            this.handleNavigationAfterBookingSaved();
          }
        },
        error => {
          if (this.isUpdate) {
            this.isError = true;
            this.toastr.warning(error.desc, "Error");
            this.toolService.showConsoleLog(error);
          }
          else {
            this.isError = true;
            this.toastr.warning(error.desc, "Error");
            this.toolService.showConsoleLog(error);
          }
        },
      ).catch();
  }

  handleNavigationAfterBookingSaved(){
    setTimeout(() => {
      this.router.navigate(['/booking']);
    }, 1000);
  }

  loadCourts = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.dbActiveData = Array();
      this.localInterfaceSrv.getCourts(facilityId)
        .then(res => {
          this.responseData = Object.values(res);
          this.responseData[0].forEach(item => {
            if (item.status == 'A') {
              const newObj = item;
              this.dbActiveData.push(newObj);
            }
          });
          this.courts = this.dbActiveData;
          this.courts.offers = res.offers;
          this.courts.content = this.dbActiveData;
          //this.taxPercentage = this.courts.content.taxPercentage/100;
          resolve(res);
        })
        .catch(err => {
          reject(err);
          this.toolService.showConsoleLog(err)
          this.toastr.error(err.desc, "Error");
        })
        .finally();
    });
  }
  loadBookingCategory = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.dbActiveData = Array();
      this.localInterfaceSrv.getBookingCategory(facilityId)
        .then(res => {
          this.responseData = Object.values(res);
          this.responseData[0].forEach(item => {
            if (item.status == 'A') {
              const newObj = item;
              this.dbActiveData.push(newObj);
            }
          });
          this.bookingCategories = this.dbActiveData;
          this.bookingCategories.content = this.dbActiveData;
          //this.taxPercentage = this.courts.content.taxPercentage/100;
          resolve(res);
        })
        .catch(err => {
          reject(err);
          this.toolService.showConsoleLog(err)
          this.toastr.error(err.desc, "Error");
        })
        .finally();
    });
  }
  loadCoaches = () => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.dbActiveData = Array();
      this.localInterfaceSrv.getCoachesByFacility()
        .then(res => {
          this.responseData = Object.values(res);
          this.coaches = res;
          //this.taxPercentage = this.courts.content.taxPercentage/100;
          resolve(res);
        })
        .catch(err => {
          reject(err);
          this.toolService.showConsoleLog(err)
          this.toastr.error(err.desc, "Error");
        })
        .finally();
    });
  }
  loadPaymentMethods = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getPaymentMethods(facilityId)
        .then(res => {
          this.paymentMethods = res;
          resolve(res);
        })
        .catch(err => {
          reject(err);
          this.toolService.showConsoleLog(err)
          this.toastr.error(err.desc, "Error");
        })
        .finally(() => this.isLoading = false);
    });
  }
  loadAddons = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getAddons(facilityId)
        .then(res => {
          this.bookingAddons = res;
          resolve(res);
        })
        .catch(err => {
          reject(err);
          this.toolService.showConsoleLog(err)
          this.toastr.error(err.desc, "Error");
        })
        .finally();
    });
  }
  loadBookingsById = (bookingId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getBookingsById(bookingId)
        .then(res => {
          this.resData = res.content;
          this.bookingId = this.resData['id'];
          this.memberId = this.resData['memberId'];
          this.classId = this.resData['classId'];
          this.bookingCategoryId = this.resData['bookingCategoryId'];
          this.coachId = this.resData['coachId'];
          this.relatedIds = this.resData['relatedIds'];
          this.court = this.resData['courtId'];
          this.channel = this.resData['channel'];
          this.customerName = this.resData['customerName'];
          this.customerMobile = this.resData['customerMobile'];
          this.customerCountryCode = this.resData['customerCountryCode'];
          this.startTime = this.resData['startTime'] != null ? new Date(this.resData['startTime'].replace(/-/g, "/")) : this.resData['startTime'];
          this.matchId = this.resData['matchId'];

          //Set end time duration
          var endTime = this.resData['endTime'] != null ? new Date(this.resData['endTime'].replace(/-/g, "/")) : this.resData['endTime'];
          const duration = (endTime.getTime() - this.startTime.getTime()) / 60000;
          endTime.setMinutes(endTime.getMinutes() + Number(duration));
          this.endTiming = duration;


          this.subTotalPrice = this.resData['subTotalPrice'];
          this.bookingAddon = this.resData['addOn'] === null ? '0' : this.resData['addOn'];
          this.tax = this.resData['taxPrice'];
          this.totalDiscount = this.resData['totalDiscount'];
          this.totalPrice = this.resData['totalPrice'];
          this.paidAmount = this.resData['paidAmount'] != null ? this.resData['paidAmount'] : 0;
          this.ccy = this.storageSrv.getFacilityCcy();
          // this.paymentMethod = this.resData['paymentMethod'] == null ? null : this.resData['paymentMethod'];
          this.paymentMethod = null;
          this.taxPercentage = this.resData['taxPercentage'] / 100;
          this.paymentStatus = this.resData['paymentStatus'];
          this.paidDate = this.resData['paidDate'] != null ? new Date(this.resData['paidDate'].replace(/-/g, "/")) : this.resData['paidDate'];
          this.isReoccur = this.resData['isReoccur'];
          this.notes = this.resData['notes'];
          this.noShow = this.resData['noShow'];
          this.cancelled = this.resData['cancelled'];
          this.cancelledDate = new Date(this.resData['cancelledDate']);
          this.bookingDate = this.resData['startTime'] != null ? new Date(this.resData['startTime'].replace(/-/g, "/")) : this.resData['startTime'];
          this.bookingAddonsArray = this.resData["addons"] != null ? this.resData["addons"] : [];
          this.trnData = this.resData["transactions"];
          this.paidOfflineAmount = '';
          this.totalRemainingAmount = this.roundTo(parseFloat(this.totalPrice) - parseFloat(this.paidAmount), 3);
          this.matchType = this.resData['matchType'];
          this.matchCategory = this.resData['matchCategory'];
          this.matchAccess = this.resData['matchAccess'];
          this.matchNoOfSets = this.resData['matchNoOfSets'];
          this.matchNotes = this.resData['matchNotes'];
          this.membershipName = this.resData['membershipName'];
          this.membershipDescription = this.resData['membershipDescription'];
          this.noOfPlayers = this.resData['noOfPlayers'];
          this.classPrice = this.resData['classPrice'];
          this.descriptionEn = this.resData['descriptionEn'];
          this.descriptionAr = this.resData['descriptionAr'];
          //this.simpleForm.patchValue({court: this.court});
          resolve(res);
        })
        .catch(err => {
          reject(err);
          this.toolService.showConsoleLog(err)
          this.toastr.error(err.desc, "Error");
        })
        .finally(
      );
    });
  }
  loadTimingSlots = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getTimingSlots(facilityId)
        .then(res => {
          this.timingSlots = res.content;
          if (this.timingSlots == '') {
            var defaultSlots: Array<{ nameEn: string, timingInMinutes: number }> = [];
            defaultSlots.push({
              nameEn: '30 Minutes',
              timingInMinutes: 30
            });
            defaultSlots.push({
              nameEn: '1 Hour',
              timingInMinutes: 60
            });
            defaultSlots.push({
              nameEn: '1 Hour 30 Minutes',
              timingInMinutes: 90
            });
            defaultSlots.push({
              nameEn: '2 Hours',
              timingInMinutes: 120
            });
            defaultSlots.push({
              nameEn: '2 Hours 30 Minutes',
              timingInMinutes: 150
            });
            defaultSlots.push({
              nameEn: '3 Hours',
              timingInMinutes: 180
            });
            defaultSlots.push({
              nameEn: '3 Hours 30 Minutes',
              timingInMinutes: 210
            });
            defaultSlots.push({
              nameEn: '4 Hours',
              timingInMinutes: 240
            });
            defaultSlots.push({
              nameEn: '4 Hours 30 Minutes',
              timingInMinutes: 270
            });
            defaultSlots.push({
              nameEn: '5 Hours',
              timingInMinutes: 300
            });
            defaultSlots.push({
              nameEn: '5 Hours 30 Minutes',
              timingInMinutes: 330
            });
            defaultSlots.push({
              nameEn: '6 Hours',
              timingInMinutes: 360
            });
            this.timingSlots = defaultSlots;
          }
          resolve(res);
        })
        .catch(err => {
          reject(err);
          this.toolService.showConsoleLog(err)
          this.toastr.error(err.desc, "Error");
        })
        .finally(
      );
    });
  }
  loadTeams = () => {
    var defaultSlots: Array<{ nameEn: string, code: string }> = [];
    defaultSlots.push({
      nameEn: 'Team A - Player 1',
      code: 'player1Aid'
    });
    defaultSlots.push({
      nameEn: 'Team A - Player 2',
      code: 'player2Aid'
    });
    defaultSlots.push({
      nameEn: 'Team B - Player 1',
      code: 'player1Bid'
    });
    defaultSlots.push({
      nameEn: 'Team B - Player 2',
      code: 'player2Bid'
    });
    this.teams = defaultSlots;
  }
  async delay(ms: number) {
    //await new Promise(resolve => setTimeout(()=>resolve(), ms)).then(()=>this.toolService.showConsoleLog("fired"));
  }
  collapsed(event: any): void {
    // this.toolService.showConsoleLog(event);
  }
  updateData(name: string): void {
    this.updateData['nameEn'] = name;
  }
  expanded(event: any): void {
    // this.toolService.showConsoleLog(event);
  }
  toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
    this.iconCollapse = this.isCollapsed ? 'icon-arrow-down' : 'icon-arrow-up';
  }
  public addAddonForAdd() {
    if (this.f['bookingAddonInstances'].value != '' && this.f['addon'].value != null) {
      var noInstances = parseInt(this.f['bookingAddonInstances'].value);
      var selectedAddon = this.f['addon'].value.split("|");

      var price = parseFloat(selectedAddon[2]);
      if (noInstances > 0) {
      }
      else {
        return;
      }
      var total = noInstances * price;
      this.simpleForm.patchValue({ bookingAddon: this.f['bookingAddon'].value + total });

      var isExisting = false;
      this.bookingAddonsArray.forEach(element => {
        if (element.id == selectedAddon[0]) {
          isExisting = true;
          var index = this.bookingAddonsArray.splice(this.bookingAddonsArray.indexOf(element), 1);
          this.bookingAddonsArray.push({
            id: selectedAddon[0],
            name: selectedAddon[1],
            count: parseInt(element.count.toString()) + parseInt(noInstances.toString()),
            price: price
          });
        }
      });

      if (!isExisting) {
        this.bookingAddonsArray.push({
          id: selectedAddon[0],
          name: selectedAddon[1],
          count: noInstances,
          price: price
        });
      }

      //this.bookingAddonsArray[0];

      //this.toolService.showConsoleLog('total' + total);
      //this.toolService.showConsoleLog('noInstances' + noInstances);
      //this.toolService.showConsoleLog('price' + price);
    }
    this.updatePriceForAdd();
    this.isAddonBtn = false;
    this.simpleForm.patchValue({ addon: null });
    this.simpleForm.patchValue({ bookingAddonInstances: null, disabled: true });
    this.f['bookingAddonInstances'].disable();
  }
  public updateAddonForAdd() {
    this.isAddonBtn = true;
    this.f['bookingAddonInstances'].enable();
  }
  public removeAddonForAdd(addonId: number) {
    this.bookingAddonsArray = this.bookingAddonsArray.filter(({ id }) => id !== addonId);
    this.updatePriceForAdd();
  }
  public addAddonForEdit() {
    if (this.f['bookingAddonInstances'].value != '' && this.f['addon'].value != null) {
      var noInstances = parseInt(this.f['bookingAddonInstances'].value);
      var selectedAddon = this.f['addon'].value.split("|");

      var price = parseFloat(selectedAddon[2]);
      if (noInstances > 0) {
      }
      else {
        return;
      }
      var total = noInstances * price;
      this.simpleForm.patchValue({ bookingAddon: this.f['bookingAddon'].value + total });

      var isExisting = false;

      for (let index = 0; index < this.bookingAddonsArray?.length; index++) {
        const element = this.bookingAddonsArray[index];
        if (element.id == selectedAddon[0]) {
          isExisting = true;
          this.bookingAddonsArray?.splice(this.bookingAddonsArray?.indexOf(element), 1);
          this.bookingAddonsArray?.push({
            id: selectedAddon[0],
            name: selectedAddon[1],
            count: parseInt(element.count.toString()) + parseInt(noInstances.toString()),
            price: price
          });
          break;
        }
      }

      if (!isExisting) {
        this.bookingAddonsArray?.push({
          id: selectedAddon[0],
          name: selectedAddon[1],
          count: noInstances,
          price: price
        });
      }
    }
    this.updatePriceForEdit();
    this.isAddonBtn = false;
    this.simpleForm.patchValue({ addon: null });
    this.simpleForm.patchValue({ bookingAddonInstances: null, disabled: true });
    this.f['bookingAddonInstances'].disable();
  }
  public updateAddonForEdit() {
    this.isAddonBtn = true;
    this.f['bookingAddonInstances'].enable();
  }
  public removeAddonForEdit(addonId: number) {
    this.bookingAddonsArray = this.bookingAddonsArray.filter(({ id }) => id !== addonId);
    this.updatePriceForEdit();
  }
  public addAddon() {
    if (this.isUpdate) {
      this.addAddonForEdit();
    }
    else {
      this.addAddonForAdd();
    }
    this.simpleForm.markAsDirty();
  }
  public updateAddon() {
    if (this.isUpdate) {
      this.updateAddonForEdit();
    }
    else {
      this.updateAddonForAdd();
    }
    this.simpleForm.markAsDirty();
  }
  public removeAddon(addonId: number) {
    if (this.isUpdate) {
      this.removeAddonForEdit(addonId);
    }
    else {
      this.removeAddonForAdd(addonId);
    }
    this.simpleForm.markAsDirty();
  }
  public updatePriceForAddPrice() {
    var subTotalPrice;
    var addon;
    var vat;
    var total;
    var totalReoccur;
    var addonTotalPrice = 0.0;
    // var startDate = new Date(this.simpleForm.controls['startTime'] ? this.f['startTime'].value : '');
    // var endDate = new Date(this.simpleForm.controls['endTime'] ? this.f['endTime'].value : '');
    this.isReoccur = this.simpleForm.controls['isReoccur'] ? this.f['isReoccur'].value : '';
    const duration = this.simpleForm.controls['endTiming'] != null ? this.f['endTiming'].value : 0;

    var reoccurInstances;
    if (this.isReoccur == "1") {
      if (this.f['bookingReOccurInstance'].value == '' || this.f['bookingReOccurInstance'].value == null || this.f['bookingReOccurInstance'].value == '0') {
        reoccurInstances = 1;
      }
      else {
        reoccurInstances = parseInt(this.f['bookingReOccurInstance'].value);
      }
    }

    var existingSubTotalPrice = parseFloat(this.simpleForm.controls['subTotalPrice'] ? this.f['subTotalPrice'].value : 0);
    var existingAddonPrice = parseFloat(this.simpleForm.controls['bookingAddon'] ? this.f['bookingAddon'].value : 0);
    var existingVATPrice = parseFloat(this.simpleForm.controls['tax'] ? this.f['tax'].value : 0);
    var existingTotalPrice = parseFloat(this.simpleForm.controls['totalPrice'] ? this.f['totalPrice'].value : 0);

    var newSubTotalPrice = parseFloat(this.simpleForm.controls['subTotalPrice'] ? this.f['subTotalPrice'].value : 0);
    var newAddonPrice = 0.0;
    var newVATPrice = 0.0;
    var newTotalPrice = 0.0;

    if (duration == 30) {
      this.courtPrice = this.courtPrice30min;
    }
    else if (duration == 60) {
      this.courtPrice = this.courtPrice60min;
    }
    else if (duration == 90) {
      this.courtPrice = this.courtPrice90min;
    }
    else if (duration == 120) {
      this.courtPrice = this.courtPrice120min;
    }
    else if (duration > 120) {
      var totalExtraTime = duration - 120;
      var totalExtraSlots = totalExtraTime / 30;
      var totalExtraPrice = totalExtraSlots * this.courtPrice30min;
      this.courtPrice = this.courtPrice120min + totalExtraPrice;
    }
    else {
      this.courtPrice = this.courtPrice120min;
    }
    if (duration == null) {
      this.courtPrice = this.courtPrice30min;
    }

    subTotalPrice = this.courtPrice;

    //1
    //newSubTotalPrice = this.courtPrice;

    for (let addonItem of this.bookingAddonsArray) {
      var addonItemPrice = addonItem.price * addonItem.count;
      addonTotalPrice = addonTotalPrice + addonItemPrice;
    }

    //2
    newAddonPrice = addonTotalPrice;

    //3
    var totalPriceWithAddon = (newSubTotalPrice + newAddonPrice);
    vat = totalPriceWithAddon * this.taxPercentage;
    newVATPrice = vat;

    //4
    newTotalPrice = newSubTotalPrice + newAddonPrice + vat;


    var finalSubTotalPrice = 0.0;
    var finalAddonPrice = 0.0;
    var finalVATPrice = 0.0;
    var finalTotalPrice = 0.0;


    if (this.isReoccur == "1") {
      //var subTotalPriceR = subTotalPrice * reoccurInstances;
      //var vatR = vat * reoccurInstances;
      totalReoccur = total * reoccurInstances;
    }

    this.toolService.showConsoleLog('duration ' + duration);
    this.toolService.showConsoleLog('courtPrice ' + this.courtPrice);
    this.toolService.showConsoleLog('subTotalPrice ' + newSubTotalPrice);
    this.toolService.showConsoleLog('vat ' + newVATPrice);
    this.toolService.showConsoleLog('addon ' + newAddonPrice);
    this.toolService.showConsoleLog('total ' + newTotalPrice);
    this.toolService.showConsoleLog('totalReoccur ' + totalReoccur);

    //this.simpleForm.patchValue({subTotalPrice: this.roundTo(newSubTotalPrice, 3), disabled:true});
    this.simpleForm.patchValue({ bookingAddon: this.roundTo(newAddonPrice, 3) });
    this.simpleForm.patchValue({ tax: this.roundTo(newVATPrice, 3), disabled: true });
    this.simpleForm.patchValue({ totalPrice: this.roundTo(newTotalPrice, 3) });
    this.simpleForm.patchValue({ bookingTotalWithReoocur: this.roundTo(totalReoccur, 3) });

    var existingTotalPrice = parseFloat(this.simpleForm.controls['totalPrice'] ? this.f['totalPrice'].value : 0);
    var newTotalPrice = parseFloat(this.simpleForm.controls['newBookingTotal'] ? this.f['newBookingTotal'].value : 0);
    var diff = (newTotalPrice - existingTotalPrice);
    this.simpleForm.patchValue({ totalRemainingAmount: this.roundTo(diff, 3) });

  }
  public updatePriceForEditPrice() {
    var subTotalPrice;
    var addon;
    var vat;
    var total;
    var totalReoccur;
    var addonTotalPrice = 0.0;
    this.isReoccur = this.simpleForm.controls['isReoccur'] ? this.f['isReoccur'].value : '';
    const duration = this.simpleForm.controls['endTiming'] != null ? this.f['endTiming'].value : 0;
    this.totalDiscount = this.simpleForm.controls['totalDiscount'] != null ? this.f['totalDiscount'].value : 0;

    var reoccurInstances;
    if (this.isReoccur) {
      if (this.f['bookingReOccurInstance'].value == '' || this.f['bookingReOccurInstance'].value == null || this.f['bookingReOccurInstance'].value == '0') {
        reoccurInstances = 1;
      }
      else {
        reoccurInstances = parseInt(this.f['bookingReOccurInstance'].value);
      }
    }


    var existingSubTotalPrice = parseFloat(this.simpleForm.controls['subTotalPrice'] ? this.f['subTotalPrice'].value : 0);
    var existingAddonPrice = parseFloat(this.simpleForm.controls['bookingAddon'] ? this.f['bookingAddon'].value : 0);
    var existingVATPrice = parseFloat(this.simpleForm.controls['tax'] ? this.f['tax'].value : 0);
    var existingTotalPrice = parseFloat(this.simpleForm.controls['totalPrice'] ? this.f['totalPrice'].value : 0);

    //var newSubTotalPrice = parseFloat(this.simpleForm.controls['newBookingPrice'] ? this.f['newBookingPrice'].value : 0);
    var newSubTotalPrice = isNaN(existingSubTotalPrice) ? 0 : existingSubTotalPrice;
    this.toolService.showConsoleLog("newSubTotalPrice" + newSubTotalPrice);
    var newAddonPrice = 0.0;
    var newVATPrice = 0.0;
    var newTotalPrice = 0.0;


    if (duration == 30) {
      this.courtPrice = this.courtPrice30min;
    }
    else if (duration == 60) {
      this.courtPrice = this.courtPrice60min;
    }
    else if (duration == 90) {
      this.courtPrice = this.courtPrice90min;
    }
    else if (duration == 120) {
      this.courtPrice = this.courtPrice120min;
    }
    else if (duration > 120) {
      var totalExtraTime = duration - 120;
      var totalExtraSlots = totalExtraTime / 30;
      var totalExtraPrice = totalExtraSlots * this.courtPrice30min;
      this.courtPrice = this.courtPrice120min + totalExtraPrice;
    }
    else {
      this.courtPrice = this.courtPrice120min;
    }

    //subTotalPrice = this.courtPrice;

    //1
    //newSubTotalPrice = this.courtPrice;

    if (this.bookingAddonsArray.length > 0) {
      if (this.existingBookingAddonArray != null) {
        if (this.bookingAddonsArray.length >= this.existingBookingAddonArray.length) {
          for (let addonItem of this.bookingAddonsArray) {
            var addonItemPrice = addonItem.price * addonItem.count;
            addonTotalPrice = addonTotalPrice + addonItemPrice;
          }
          newAddonPrice = addonTotalPrice;
        }
        else if (this.bookingAddonsArray.length < this.existingBookingAddonArray.length) {
          for (let addonItem of this.bookingAddonsArray) {
            var addonItemPrice = addonItem.price * addonItem.count;
            addonTotalPrice = addonTotalPrice - addonItemPrice;
          }
          newAddonPrice = addonTotalPrice * -1;
        }
        else {
          newAddonPrice = existingAddonPrice;
        }
      }
      else {
        newAddonPrice = existingAddonPrice;
      }
    }
    else if (this.bookingAddonsArray.length == 0) {
      newAddonPrice = 0;
    }
    else {
      newAddonPrice = existingAddonPrice;
    }

    //2

    //3
    var totalPriceWithAddon = (newSubTotalPrice + newAddonPrice);
    vat = totalPriceWithAddon * this.taxPercentage;
    newVATPrice = vat;

    if (this.totalDiscount > 0) {
      var discountedSubTotalPrice = newSubTotalPrice - (newSubTotalPrice * (this.totalDiscount / 100));
      newTotalPrice = discountedSubTotalPrice + newAddonPrice + newVATPrice;
    }
    else {
      this.totalDiscount = 0;
      newTotalPrice = newSubTotalPrice + newAddonPrice + newVATPrice;
    }

    //4

    var finalSubTotalPrice = 0.0;
    var finalAddonPrice = 0.0;
    var finalVATPrice = 0.0;
    var finalTotalPrice = 0.0;



    if (this.isReoccur) {
      //var subTotalPriceR = subTotalPrice * reoccurInstances;
      //var vatR = vat * reoccurInstances;
      totalReoccur = total * reoccurInstances;
    }

    this.toolService.showConsoleLog('duration ' + duration);
    this.toolService.showConsoleLog('courtPrice ' + this.courtPrice);
    this.toolService.showConsoleLog('this.taxPercentage ' + this.taxPercentage);
    this.toolService.showConsoleLog('newSubTotalPrice ' + newSubTotalPrice);
    this.toolService.showConsoleLog('newVATPrice ' + newVATPrice);
    this.toolService.showConsoleLog('newAddonPrice ' + newAddonPrice);
    this.toolService.showConsoleLog('newTotalPrice ' + newTotalPrice);
    this.toolService.showConsoleLog('totalReoccur ' + totalReoccur);

    //this.simpleForm.patchValue({newBookingPrice: this.roundTo(newSubTotalPrice, 3), disabled:true});
    this.simpleForm.patchValue({ bookingAddon: this.roundTo(newAddonPrice, 3) });
    this.simpleForm.patchValue({ tax: this.roundTo(newVATPrice, 3), disabled: true });
    this.simpleForm.patchValue({ totalPrice: this.roundTo(newTotalPrice, 3) });
    this.simpleForm.patchValue({ bookingTotalWithReoocur: this.roundTo(totalReoccur, 3) });
    this.simpleForm.patchValue({ totalDiscount: this.roundTo(this.totalDiscount, 3) });

    //var existingTotalPrice = parseFloat(this.simpleForm.controls['totalPrice'] ? this.f['totalPrice'].value : 0);
    //var newTotalPrice = parseFloat(this.simpleForm.controls['totalPrice'] ? this.f['newBookingTotal'].value: 0);
    var diff = (newTotalPrice - existingTotalPrice);
    this.simpleForm.patchValue({ totalRemainingAmount: this.roundTo(diff, 3) });
  }
  public updatePriceForPrice() {
    if (this.isUpdate) {
      this.updatePriceForEditPrice();
    }
    else {
      this.updatePriceForAddPrice();
    }
    this.simpleForm.markAsDirty();
  }
  public updatePriceForAdd() {
    var subTotalPrice;
    var addon;
    var vat;
    var total;
    var totalReoccur;
    var addonTotalPrice = 0.0;

    var startDateT = moment(new Date(this.simpleForm.controls['bookingDate'] ? this.f['bookingDate'].value : null)).format("YYYY-MM-DD");
    var startTime = moment(this.simpleForm.controls['startTime'] ? this.f['startTime'].value : null).format("HH:mm:ss");

    var startDate = new Date(startDateT + ' ' + startTime);
    var startDateM = new Date(startDateT + ' ' + startTime);

    //this.toolService.showConsoleLog(startDate);
    //var startDate = new Date(this.simpleForm.controls['bookingDate'] ? this.f['startTime'].value + ' ' + this.f['bookingDate'].value : null);
    //this.toolService.showConsoleLog(startDate);
    // var endDate = new Date(this.simpleForm.controls['endTime'] ? this.f['endTime'].value : '');
    this.isReoccur = this.simpleForm.controls['isReoccur'] ? this.f['isReoccur'].value : '';
    const duration = this.simpleForm.controls['endTiming'] != null ? this.f['endTiming'].value : 0;
    //const duration = this.roundTo(((endDate.getTime() - startDate.getTime())/60000),0);
    let selectedCourtId = this.simpleForm.controls['court'] ? this.f['court'].value : 0;

    var reoccurInstances;
    if (this.isReoccur == "1") {
      if (this.f['bookingReOccurInstance'].value == '' || this.f['bookingReOccurInstance'].value == null || this.f['bookingReOccurInstance'].value == '0') {
        reoccurInstances = 1;
      }
      else {
        reoccurInstances = parseInt(this.f['bookingReOccurInstance'].value);
      }
    }

    var existingSubTotalPrice = parseFloat(this.simpleForm.controls['subTotalPrice'] ? this.f['subTotalPrice'].value : 0);
    var existingAddonPrice = parseFloat(this.simpleForm.controls['bookingAddon'] ? this.f['bookingAddon'].value : 0);
    var existingVATPrice = parseFloat(this.simpleForm.controls['tax'] ? this.f['tax'].value : 0);
    var existingTotalPrice = parseFloat(this.simpleForm.controls['totalPrice'] ? this.f['totalPrice'].value : 0);

    var newSubTotalPrice = 0.0;
    var newAddonPrice = 0.0;
    var newVATPrice = 0.0;
    var newTotalPrice = 0.0;

    //this.toolService.showConsoleLog("this.simpleForm.controls['court']" + this.simpleForm.controls['court']);

    if (!this.simpleForm.controls['court']) {
      selectedCourtId = null;
    }
    else {
      this.updateCourtOfferPrices(selectedCourtId, startDate, startDateM, duration)
    }

    if (duration == 30) {
      this.courtPrice = this.courtPrice30min;
    }
    else if (duration == 60) {
      this.courtPrice = this.courtPrice60min;
    }
    else if (duration == 90) {
      this.courtPrice = this.courtPrice90min;
    }
    else if (duration == 120) {
      this.courtPrice = this.courtPrice120min;
    }
    else if (duration > 120) {
      var totalExtraTime = duration - 120;
      var totalExtraSlots = totalExtraTime / 30;
      var totalExtraPrice = totalExtraSlots * this.courtPrice30min;
      this.courtPrice = this.courtPrice120min + totalExtraPrice;
    }
    else {
      this.courtPrice = this.courtPrice120min;
    }

    if (duration == null) {
      this.courtPrice = this.courtPrice30min;
    }

    subTotalPrice = this.courtPrice;

    //1
    newSubTotalPrice = this.courtPrice;

    for (let addonItem of this.bookingAddonsArray) {
      var addonItemPrice = addonItem.price * addonItem.count;
      addonTotalPrice = addonTotalPrice + addonItemPrice;
    }

    //2
    newAddonPrice = addonTotalPrice;

    //3
    var totalPriceWithAddon = (newSubTotalPrice + newAddonPrice);
    vat = totalPriceWithAddon * this.taxPercentage;
    newVATPrice = vat;

    //4
    newTotalPrice = newSubTotalPrice + newAddonPrice + vat;


    var finalSubTotalPrice = 0.0;
    var finalAddonPrice = 0.0;
    var finalVATPrice = 0.0;
    var finalTotalPrice = 0.0;


    if (this.isReoccur == "1") {
      //var subTotalPriceR = subTotalPrice * reoccurInstances;
      //var vatR = vat * reoccurInstances;
      totalReoccur = total * reoccurInstances;
    }

    this.toolService.showConsoleLog('duration ' + duration);
    this.toolService.showConsoleLog('courtPrice ' + this.courtPrice);
    this.toolService.showConsoleLog('subTotalPrice ' + newSubTotalPrice);
    this.toolService.showConsoleLog('vat ' + newVATPrice);
    this.toolService.showConsoleLog('addon ' + newAddonPrice);
    this.toolService.showConsoleLog('total ' + newTotalPrice);
    this.toolService.showConsoleLog('totalReoccur ' + totalReoccur);

    this.simpleForm.patchValue({ subTotalPrice: this.roundTo(newSubTotalPrice, 3), disabled: true });
    this.simpleForm.patchValue({ bookingAddon: this.roundTo(newAddonPrice, 3) });
    this.simpleForm.patchValue({ tax: this.roundTo(newVATPrice, 3), disabled: true });
    this.simpleForm.patchValue({ totalPrice: this.roundTo(newTotalPrice, 3) });
    this.simpleForm.patchValue({ bookingTotalWithReoocur: this.roundTo(totalReoccur, 3) });

    //var existingTotalPrice = parseFloat(this.simpleForm.controls['totalPrice'] ? this.f['totalPrice'].value : 0);
    //var newTotalPrice = parseFloat(this.simpleForm.controls['newBookingTotal'] ? this.f['newBookingTotal'].value : 0);
    var diff = (newTotalPrice - existingTotalPrice);
    this.simpleForm.patchValue({ totalRemainingAmount: this.roundTo(diff, 3) });

  }
  public updatePriceForEdit() {
    var subTotalPrice;
    var vat;
    var total;
    var totalReoccur;
    var addonTotalPrice = 0.0;
    this.isReoccur = this.simpleForm.controls['isReoccur'] ? this.f['isReoccur'].value : '';

    var startDateT = moment(new Date(this.simpleForm.controls['bookingDate'] ? this.f['bookingDate'].value : null)).format("YYYY-MM-DD");
    var startTime = moment(this.simpleForm.controls['startTime'] ? this.f['startTime'].value : null).format("HH:mm:ss");

    var startDate = new Date(startDateT + ' ' + startTime);
    var startDateM = new Date(startDateT + ' ' + startTime);

    // var startDate = new Date(this.simpleForm.controls['startTime'] ? this.f['startTime'].value : '');
    // var startDateM = new Date(this.simpleForm.controls['startTime'] ? this.f['startTime'].value : '');
    const duration = this.simpleForm.controls['endTiming'] != null ? Number(this.f['endTiming'].value) : 0;
    let selectedCourtId = this.simpleForm.controls['court'] ? this.f['court'].value : 0;

    if (this.totalDiscount == null) {
      this.totalDiscount = this.simpleForm.controls['totalDiscount'] != null ? this.f['totalDiscount'].value : 0;
    }

    var reoccurInstances;
    if (this.isReoccur) {
      if (this.f['bookingReOccurInstance'].value == '' || this.f['bookingReOccurInstance'].value == null || this.f['bookingReOccurInstance'].value == '0') {
        reoccurInstances = 1;
      }
      else {
        reoccurInstances = parseInt(this.f['bookingReOccurInstance'].value);
      }
    }

    if (!this.simpleForm.controls['court']) {
      selectedCourtId = null;
    }
    else {
      this.updateCourtOfferPrices(selectedCourtId, startDate, startDateM, duration)
    }

    var existingSubTotalPrice = parseFloat(this.simpleForm.controls['subTotalPrice'] ? this.f['subTotalPrice'].value : 0);
    var existingAddonPrice = parseFloat(this.simpleForm.controls['bookingAddon'] ? this.f['bookingAddon'].value : 0);
    var existingVATPrice = parseFloat(this.simpleForm.controls['tax'] ? this.f['tax'].value : 0);
    var existingTotalPrice = parseFloat(this.simpleForm.controls['totalPrice'] ? this.f['totalPrice'].value : 0);
    var paidAmount = parseFloat(this.simpleForm.controls['paidAmount'] ? this.f['paidAmount'].value : 0);

    var newSubTotalPrice = parseFloat(this.simpleForm.controls['subTotalPrice'] ? this.f['subTotalPrice'].value : 0);
    var newAddonPrice = 0.0;
    var newVATPrice = 0.0;
    var newTotalPrice = 0.0;

    if (duration == 30) {
      this.courtPrice = this.courtPrice30min;
    }
    else if (duration == 60) {
      this.courtPrice = this.courtPrice60min;
    }
    else if (duration == 90) {
      this.courtPrice = this.courtPrice90min;
    }
    else if (duration == 120) {
      this.courtPrice = this.courtPrice120min;
    }
    else if (duration > 120) {
      var totalExtraTime = duration - 120;
      var totalExtraSlots = totalExtraTime / 30;
      var totalExtraPrice = totalExtraSlots * this.courtPrice30min;
      this.courtPrice = this.courtPrice120min + totalExtraPrice;
    }
    else {
      this.courtPrice = this.courtPrice120min;
    }

    //subTotalPrice = this.courtPrice;

    //1
    newSubTotalPrice = this.courtPrice;

    if (this.bookingAddonsArray?.length > 0) {
      if (this.existingBookingAddonArray != null) {
        if (this.bookingAddonsArray.length >= this.existingBookingAddonArray.length) {
          for (let addonItem of this.bookingAddonsArray) {
            var addonItemPrice = addonItem.price * addonItem.count;
            addonTotalPrice = addonTotalPrice + addonItemPrice;
          }
          newAddonPrice = addonTotalPrice;
        }
        else if (this.bookingAddonsArray.length < this.existingBookingAddonArray.length) {
          for (let addonItem of this.bookingAddonsArray) {
            var addonItemPrice = addonItem.price * addonItem.count;
            addonTotalPrice = addonTotalPrice - addonItemPrice;
          }
          newAddonPrice = addonTotalPrice * -1;
        }
        else {
          newAddonPrice = existingAddonPrice;
        }
      }
      else {
        newAddonPrice = existingAddonPrice;
      }
    }
    else if (this.bookingAddonsArray?.length == 0) {
      newAddonPrice = 0;
    }
    else {
      newAddonPrice = existingAddonPrice;
    }
    //2

    //3
    var totalPriceWithAddon = (newSubTotalPrice + newAddonPrice);
    vat = totalPriceWithAddon * this.taxPercentage;
    newVATPrice = vat;

    //4
    if (this.totalDiscount > 0) {
      newSubTotalPrice = newSubTotalPrice - (newSubTotalPrice * (this.totalDiscount / 100));
    }
    else {
      this.totalDiscount = 0;
    }

    newTotalPrice = newSubTotalPrice + newAddonPrice + newVATPrice;

    if (this.isReoccur) {
      totalReoccur = total * reoccurInstances;
    }

    this.simpleForm.patchValue({ bookingAddon: this.roundTo(newAddonPrice, 3) });
    this.simpleForm.patchValue({ tax: this.roundTo(newVATPrice, 3), disabled: true });
    this.simpleForm.patchValue({ totalPrice: this.roundTo(newTotalPrice, 3) });
    this.simpleForm.patchValue({ bookingTotalWithReoocur: this.roundTo(totalReoccur, 3) });

    var diff = (newTotalPrice - paidAmount);
    // if (diff != 0)
    // {
    //   this.simpleForm.patchValue({totalRemainingAmount: this.roundTo(diff, 3)});
    // }
    //NEW ADDED
    this.simpleForm.patchValue({ totalRemainingAmount: this.roundTo(diff, 3) });

  }
  public updatePriceForEditDiscount() {
    var subTotalPrice;
    var addon;
    var vat;
    var total;
    var totalReoccur;
    var addonTotalPrice = 0.0;
    this.isReoccur = this.simpleForm.controls['isReoccur'] ? this.f['isReoccur'].value : '';
    const duration = this.simpleForm.controls['endTiming'] != null ? Number(this.f['endTiming'].value) : 0;
    this.totalDiscount = this.simpleForm.controls['totalDiscount'] != null ? this.f['totalDiscount'].value : 0;

    var reoccurInstances;
    if (this.isReoccur) {
      if (this.f['bookingReOccurInstance'].value == '' || this.f['bookingReOccurInstance'].value == null || this.f['bookingReOccurInstance'].value == '0') {
        reoccurInstances = 1;
      }
      else {
        reoccurInstances = parseInt(this.f['bookingReOccurInstance'].value);
      }
    }


    var existingSubTotalPrice = parseFloat(this.simpleForm.controls['subTotalPrice'] ? this.f['subTotalPrice'].value : 0);
    var existingAddonPrice = parseFloat(this.simpleForm.controls['bookingAddon'] ? this.f['bookingAddon'].value : 0);
    var existingVATPrice = parseFloat(this.simpleForm.controls['tax'] ? this.f['tax'].value : 0);
    var existingTotalPrice = parseFloat(this.simpleForm.controls['totalPrice'] ? this.f['totalPrice'].value : 0);
    var paidAmount = parseFloat(this.simpleForm.controls['paidAmount'] ? this.f['paidAmount'].value : 0);

    var newSubTotalPrice = 0.0;
    var newAddonPrice = 0.0;
    var newVATPrice = 0.0;
    var newTotalPrice = 0.0;

    this.toolService.showConsoleLog("MyDuration" + duration);

    subTotalPrice = existingSubTotalPrice;

    //1
    newSubTotalPrice = existingSubTotalPrice;

    if (this.bookingAddonsArray?.length > 0) {
      if (this.existingBookingAddonArray != null) {
        if (this.bookingAddonsArray.length >= this.existingBookingAddonArray.length) {
          for (let addonItem of this.bookingAddonsArray) {
            var addonItemPrice = addonItem.price * addonItem.count;
            addonTotalPrice = addonTotalPrice + addonItemPrice;
          }
          newAddonPrice = addonTotalPrice;
        }
        else if (this.bookingAddonsArray.length < this.existingBookingAddonArray.length) {
          for (let addonItem of this.bookingAddonsArray) {
            var addonItemPrice = addonItem.price * addonItem.count;
            addonTotalPrice = addonTotalPrice - addonItemPrice;
          }
          newAddonPrice = addonTotalPrice * -1;
        }
        else {
          newAddonPrice = existingAddonPrice;
        }
      }
      else {
        newAddonPrice = existingAddonPrice;
      }
    }
    else if (this.bookingAddonsArray?.length == 0) {
      newAddonPrice = 0;
    }
    else {
      newAddonPrice = existingAddonPrice;
    }

    //2

    //3
    var totalPriceWithAddon = (newSubTotalPrice + newAddonPrice);
    vat = totalPriceWithAddon * this.taxPercentage;
    newVATPrice = vat;

    //4
    // if (this.totalDiscount > 0)
    // {
    //   newSubTotalPrice = newSubTotalPrice - (newSubTotalPrice * (this.totalDiscount/100));
    // }
    // else
    // {
    //   this.totalDiscount = 0;
    // }
    // newTotalPrice = newSubTotalPrice + newAddonPrice + newVATPrice;

    if (this.totalDiscount > 0) {
      var discountedSubTotalPrice = newSubTotalPrice - (newSubTotalPrice * (this.totalDiscount / 100));
      newTotalPrice = discountedSubTotalPrice + newAddonPrice + newVATPrice;
    }
    else {
      this.totalDiscount = 0;
      newTotalPrice = newSubTotalPrice + newAddonPrice + newVATPrice;
    }



    if (this.isReoccur) {
      totalReoccur = total * reoccurInstances;
    }

    this.toolService.showConsoleLog('duration ' + duration);
    this.toolService.showConsoleLog('courtPrice ' + this.courtPrice);
    this.toolService.showConsoleLog('this.taxPercentage ' + this.taxPercentage);
    this.toolService.showConsoleLog('newSubTotalPrice ' + newSubTotalPrice);
    this.toolService.showConsoleLog('newVATPrice ' + newVATPrice);
    this.toolService.showConsoleLog('newAddonPrice ' + newAddonPrice);
    this.toolService.showConsoleLog('newTotalPrice ' + newTotalPrice);
    this.toolService.showConsoleLog('totalReoccur ' + totalReoccur);

    this.simpleForm.patchValue({ subTotalPrice: this.roundTo(newSubTotalPrice, 3) });
    this.simpleForm.patchValue({ bookingAddon: this.roundTo(newAddonPrice, 3) });
    this.simpleForm.patchValue({ tax: this.roundTo(newVATPrice, 3), disabled: true });
    this.simpleForm.patchValue({ totalPrice: this.roundTo(newTotalPrice, 3) });
    this.simpleForm.patchValue({ bookingTotalWithReoocur: this.roundTo(totalReoccur, 3) });
    this.simpleForm.patchValue({ totalDiscount: this.roundTo(this.totalDiscount, 3) });
    this.toolService.showConsoleLog("this.totalDiscount" + this.totalDiscount);

    var diff = (newTotalPrice - paidAmount);
    // if (diff != 0)
    // {
    //   this.simpleForm.patchValue({totalRemainingAmount: this.roundTo(diff, 3)});
    // }
    this.simpleForm.patchValue({ totalRemainingAmount: this.roundTo(diff, 3) });

  }
  public updatePrice() {
    if (this.isUpdate) {
      this.updatePriceForEdit();
    }
    else {
      this.updatePriceForAdd();
    }
    this.simpleForm.markAsDirty();
  }
  public updateReoccur() {
    this.updateReoccurDay();
    var status = this.f['isReoccur'].value;
    if (status == "1") {
      this.bookingReOccur = true;
      //this.f['bookingReOccurDays'].enable();
      this.f['bookingReOccurInstance'].enable();
    }
    else {
      this.bookingReOccur = false;
      //this.f['bookingReOccur'].enable();
      this.f['bookingReOccurDays'].disable();
      this.f['bookingReOccurInstance'].disable();
      this.simpleForm.patchValue({ bookingReOccurDays: null });
    }

    //this.toolService.showConsoleLog('selectedReoccurDay' + this.selectedReoccurDay);
    //this.bookingReOccur = true;
  }
  public updateReoccurDay() {
    var selectedDay = (new Date(this.bookingDate)).getDay();
    this.selectedReoccurDay = selectedDay;
  }
  public updateDate() {
    this.updateReoccurDay();
  }
  public roundTo = function (num: number, places: number) {
    const factor = 10 ** places;
    return Math.round(num * factor) / factor;
  };
  public updateCourtId(courtId) {
    //var startDate = new Date(this.f['startTime'].value);
    //var endDate = new Date(this.f['endTime'].value);
    var duration = 120;

    for (let court of this.courts.content) {
      if (court.id == courtId) {
        this.courtPrice30min = parseFloat(court["30minPrice"]);
        this.courtPrice60min = parseFloat(court["60minPrice"]);
        this.courtPrice90min = parseFloat(court["90minPrice"]);
        this.courtPrice120min = parseFloat(court["120minPrice"]);
        this.taxPercentage = court["taxPercentage"] / 100;

        if (duration == 30) {
          this.courtPrice = this.courtPrice30min;
        }
        else if (duration == 60) {
          this.courtPrice = this.courtPrice60min;
        }
        else if (duration == 90) {
          this.courtPrice = this.courtPrice90min;
        }
        else if (duration == 120) {
          this.courtPrice = this.courtPrice120min;
        }
        else if (duration > 120) {
          var totalExtraTime = duration - 120;
          var totalExtraSlots = totalExtraTime / 30;
          var totalExtraPrice = totalExtraSlots * this.courtPrice30min;
          this.courtPrice = this.courtPrice120min + totalExtraPrice;
        }
        else {
          this.courtPrice = this.courtPrice120min;
        }
      }
    }
    this.updatePrice();
  }
  public updateCancelled() {
    var status = this.f['cancelled'].value;
    if (status == '1') {
      this.cancelled = '1';
    }
    else {
      this.cancelled = '0';
    }

    //this.toolService.showConsoleLog('selectedReoccurDay' + this.selectedReoccurDay);
    //this.bookingReOccur = true;
  }
  deleteTransaction = (paymentId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      const fields = {
        paymentId: paymentId,
        bookingId: this.bookingId
      };
      this.localInterfaceSrv.deleteTransaction(paymentId, this.bookingId)
        .then(async res => {
          resolve(res);
          this.toastr.success("Payment Removed", "Success");
          this.dangerModal.hide();
          this.route.queryParams.subscribe(async params => {
            await this.loadBookingsById(this.bookingId);
            this.onSuccess();
          });
          //window.location.reload()
        })
        .catch(err => {
          reject(err);
          this.toastr.error(err.desc, "Error");
          this.dangerModal.hide();
        })
        .finally(() => this.isLoading = false);
    });
  }
  confirmPayment = (paymentId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      const fields = {
        paymentId: paymentId,
        bookingId: this.bookingId
      };
      this.localInterfaceSrv.confirmOfflinePayment(paymentId, this.bookingId)
        .then(async res => {
          resolve(res);
          this.toastr.success("Payment Confirmed", "Success");
          this.confirmModal.hide();
          this.route.queryParams.subscribe(async params => {
            await this.loadBookingsById(this.bookingId);
            this.onSuccess();
          });
          //window.location.reload()
        })
        .catch(err => {
          reject(err);
          this.toastr.error(err.desc, "Error");
          this.dangerModal.hide();
        })
        .finally(() => this.isLoading = false);
    });
  }
  cancelBooking = (bookingId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      const fields = {
        bookingId: bookingId
      };
      this.localInterfaceSrv.deleteBooking(bookingId)
        .then(async res => {
          resolve(res);
          this.toastr.success("Booking Cancelled", "Success");
          this.cancelBookingModal.hide();
          this.route.queryParams.subscribe(async params => {
            await this.loadBookingsById(bookingId);
            this.onSuccess();
          });
          //window.location.reload()
        })
        .catch(err => {
          reject(err);
          this.toastr.error(err.desc, "Error");
          this.cancelBookingModal.hide();
        })
        .finally(() => this.isLoading = false);
    });
  }
  markBookingNoShow = (bookingId) => {
    return new Promise<any>(async (resolve, reject) => {
      const fields = {
        bookingId: bookingId
      };
      this.localInterfaceSrv.markBookingNoShow(bookingId)
        .then(async res => {
          resolve(res);
          this.toastr.success("Booking marked as no show", "Success");
          this.noShowBookingModal.hide();
          this.route.queryParams.subscribe(async params => {
            await this.loadBookingsById(bookingId);
            this.onSuccess();
          });
          //window.location.reload()
        })
        .catch(err => {
          reject(err);
          this.toastr.error(err.desc, "Error");
          this.noShowBookingModal.hide();
        })
        .finally(() => this.isLoading = false);
    });
  }
  public addNewPayment() {
    var paidOfflineAmount = this.f['paidOfflineAmount'].value;
    var paymentMethod = this.selectedPaymentMethod;
    var facilityId = this.facilityId;
    var selectedPlayer = this.selectedPlayer;
    var bookingId = this.bookingId;
    var courtId = this.f['court'].value;
    var ccy = this.f['ccy'].value;

    var msg = '';
    if ((paidOfflineAmount == null || paidOfflineAmount == "null" || paidOfflineAmount <= 0) && !isNaN(paidOfflineAmount)) {
      msg = "Paid Amount not entered";
      this.toastr.warning(msg, "Warning");
      return;
    }
    if (paymentMethod == null || paymentMethod == "null" || paymentMethod == '' || paymentMethod == 'undefined' || paymentMethod == undefined) {
      msg = "Payment Method not selected";
      this.toastr.warning(msg, "Warning");
      return;
    }
    this.addPayment(facilityId, courtId, bookingId, ccy, paidOfflineAmount, paymentMethod, selectedPlayer);

  }
  addPayment = (facilityId, courtId, bookingId, ccy, paidAmount, paymentCode, selectedPlayer) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.addNewPayment(facilityId, courtId, bookingId, ccy, paidAmount, paymentCode, selectedPlayer)
        .then(async res => {
          resolve(res);
          this.toastr.success("Payment Added", "Success");
          this.addNewPaymentModal.hide();
          this.route.queryParams.subscribe(async params => {
            await this.loadBookingsById(this.bookingId);
            this.onSuccess();
          });
          //window.location.reload()
        })
        .catch(err => {
          reject(err);
          this.toastr.error(err.desc, "Error");
          this.addNewPaymentModal.hide();
        })
        .finally(() => this.isLoading = false);
    });
  }
  refundPayment = (paymentId) => {
    // var paidAmount = this.f['paidAmount'].value;
    // var bookingId = this.bookingId;
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      const fields = {
        paymentId
      };
      this.localInterfaceSrv.refundPayment(paymentId, this.sharedWallet)
        .then(async res => {
          resolve(res);
          this.toastr.success("Payment Refunded", "Success");
          this.refundPaymentModal.hide();
          this.route.queryParams.subscribe(async params => {
            await this.loadBookingsById(this.bookingId);
            this.onSuccess();
          });
          //window.location.reload()
        })
        .catch(err => {
          reject(err);
          this.toastr.error(err.desc, "Error");
          this.refundPaymentModal.hide();
        })
        .finally(() => this.isLoading = false);
    });
  }
  refundClassPayment = (paymentId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      const fields = {
        paymentId
      };
      this.localInterfaceSrv.refundPayment(paymentId, this.sharedWallet)
        .then(async res => {
          resolve(res);
          this.toastr.success("Payment Refunded", "Success");
          this.refundClassPaymentModal.hide();
          this.route.queryParams.subscribe(async params => {
            await this.loadClassPlayers(this.bookingId);
            this.onSuccess();
          });
          //window.location.reload()
        })
        .catch(err => {
          reject(err);
          this.toastr.error(err.desc, "Error");
          this.refundClassPaymentModal.hide();
        })
        .finally(() => this.isLoading = false);
    });
  }
  refundMatchPayment = (paymentId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      const fields = {
        paymentId
      };
      this.localInterfaceSrv.refundPayment(paymentId, this.sharedWallet)
        .then(async res => {
          resolve(res);
          this.toastr.success("Payment Refunded", "Success");
          this.refundClassPaymentModal.hide();
          this.route.queryParams.subscribe(async params => {
            await this.loadMatchPlayers();
            this.onSuccess();
          });
          //window.location.reload()
        })
        .catch(err => {
          reject(err);
          this.toastr.error(err.desc, "Error");
          this.refundPaymentModal.hide();
        })
        .finally(() => this.isLoading = false);
    });
  }
  removeClassPlayer = (playerId) => {
    // var paidAmount = this.f['paidAmount'].value;
    // var bookingId = this.bookingId;
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.removeClassPlayer(playerId, this.classId)
        .then(async res => {
          resolve(res);
          this.toastr.success("Player Removed", "Success");
          this.removeClassPlayerModal.hide();
          this.route.queryParams.subscribe(async params => {
            await this.loadClassPlayers(this.classId);
            this.onSuccess();
          });
          //window.location.reload()
        })
        .catch(err => {
          reject(err);
          this.toastr.error(err.desc, "Error");
          this.removeClassPlayerModal.hide();
        })
        .finally(() => this.isLoading = false);
    });
  }
  removeMatchPlayer = (playerId) => {
    // var paidAmount = this.f['paidAmount'].value;
    // var bookingId = this.bookingId;
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.removeMatchPlayer(playerId, this.matchId)
        .then(async res => {
          resolve(res);
          this.toastr.success("Player Removed", "Success");
          this.removeMatchPlayerModal.hide();
          this.route.queryParams.subscribe(async params => {
            await this.loadMatchPlayers();
            this.onSuccess();
          });
          //window.location.reload()
        })
        .catch(err => {
          reject(err);
          this.toastr.error(err.desc, "Error");
          this.removeMatchPlayerModal.hide();
        })
        .finally(() => this.isLoading = false);
    });
  }

  printViaWeb(msg) {

    const style = `*, html {margin:0;}
                  table {width: 100%; padding: 0 5px}
                  .head {color: #ccc;}
                  .center{text-align:center;}
                  .end{float: right;text-align: right;}
                  .service{padding-bottom: 5px}
                  .padding-top{padding-top: 10px;}
                  .padding-bottom{padding-bottom: 10px;}
                  .not-bold{font-weight: unset;}`;

    const myWindow = window.open('', 'Receipt', 'height=400,width=600');
    myWindow.document.write('<html><head><title>Receipt</title>');
    myWindow.document.write('<style type="text/css">' + style + '</style>');
    myWindow.document.write('</head><body>');
    myWindow.document.write(msg);

    myWindow.document.write('</body></html>');
    myWindow.document.close(); // necessary for IE >= 10


    myWindow.onload = () => { // necessary if the div contain images
      myWindow.focus(); // necessary for IE >= 10
      myWindow.print();
      myWindow.close();
    };

  }
  printWebCustomrtReceiptFn = async (booking) => {
    this.toolService.showConsoleLog('# Print Receipt');
    const facilityId = await this.storageSrv.getFacilityId();
    const facilityName = await this.storageSrv.getFacilityName();
    const facilityPhoneNumber = await this.storageSrv.getFacilityPhoneNumber();
    const facilityOfficialName = await this.storageSrv.getFacilityOfficialName();
    const facilityTaxNumber = await this.storageSrv.getFacilityTaxNumber();
    const taxId = '1';
    //const decimalPlaces = booking.decimalPlaces ? booking.decimalPlaces :  this.storageSrv.decimalPlaces;
    //const decimalPlacesInHTML = await this.storageSrv.convertDecimalPlacesToHTML(decimalPlaces);
    let receipt = '<h3 class="head center">TAX INVOICE</h3><br/>';
    let taxInfo = '';
    let facilityInfo = '';
    let bookingInfo = '';
    let customerInfo = '';
    let deliveryInfo = '';
    let receiptItem = '';
    let generalRequest = '';
    let cutlery = '';
    let total = '';
    let dateTime = '';
    const thankYou = '<h6 class="center padding-top">Thank You For The Visit</h6>';
    const arenaClub = '<h6 class="center">POWERED BY ARENA ONLINE SERVICES W.L.L</h6>';
    const newDivider = '<br/> ----------------------------------------- <br/><br/>';
    const newLine = '<br/>';
    const cutLine = '<br/><br/><h6 style="color:#fff">.</h6>';


    if (facilityTaxNumber != 'null' && facilityTaxNumber != "undefined") {

      // START - Facility Info
      facilityInfo += `<div class="center" style="padding: 0 20px;">
                  <h4>` + (facilityOfficialName != "undefined" ? facilityOfficialName + '<br>' : '') + `</h4>
                  <h4>` + (facilityTaxNumber != "undefined" ? 'TIN: ' + facilityTaxNumber + '<br>' : '') + `</h4>
                  <h4> TEL: ` + facilityPhoneNumber + `</h4>
                </div>`;
      // END - Facility Info
    }
    else {


      // START - Facility Info
      facilityInfo += `<div class="center" style="padding: 0 20px;">
      <h4>` + (facilityOfficialName != "undefined" ? facilityOfficialName + '<br>' : '') + `</h4>
                        <h4> TEL: ` + facilityPhoneNumber + `</h4>
                      </div>`;
      // END - Facility Info
    }


    // START - Customer Info
    if (booking.customerName || (booking.customerCountryCode && booking.customerMobile)) {
      customerInfo += `<div class="center">`;
      if (booking.customerName) {
        customerInfo += `<h5>` + booking.customerName.toUpperCase() + `</h5>`;
      }
      if (booking.customerCountryCode && booking.customerMobile) {
        customerInfo += `<h5>TEL: +` + booking.customerCountryCode + `-` + booking.customerMobile + `</h5>`;
      }
      customerInfo += `</div>`;
    }
    // END - Customer Info

    // START - booking Info
    bookingInfo += `<div class="center">
                      <h5>Booking ID</h5>
                      <h3 class="padding-top">#` + booking.id + `</h3>
                    </div>`;
    // END - booking Info

    // // START - Delivery option
    // deliveryInfo += '<div class="center">';
    // if (booking.type == 'dinein') {
    //   deliveryInfo += '<h5>' + booking.qrCode.nameEn + '</h5>';
    //   deliveryInfo += '<h5><span>Dine-in </span>' + booking.branchNameEn + '<span> Branch</span></h5>';
    // }
    // if (booking.type == 'pickup') {
    //   deliveryInfo += '<h5><span>Pickup from </span>' + booking.branchNameEn + '<span> Branch</span></h5>';
    //   deliveryInfo += booking?.carPlateNo && booking?.carPlateNo.trim() !== '' ? '<p>Car plate <span>' + booking.carPlateNo + '</span></p>' : '';
    //   deliveryInfo += booking?.hotelRoomNo && booking?.hotelRoomNo.trim() !== '' ? '<p>Room <span>' + booking.hotelRoomNo + '</span></p>' : '';
    // }
    // if (booking.type == 'delivery' && booking?.deliveryAddress) {
    //   deliveryInfo += `<h5>` + booking.nickname + ` (` + booking.deliveryAddress.area + `)` + `</h5>
    //                     <p>`;
    //   if (booking.deliveryAddress.type == 'apartment') {
    //     deliveryInfo += `Apartment ` + booking.deliveryAddress.building + `, Floor ` + booking.deliveryAddress.floor + `, Building `;
    //   }
    //   if (booking.deliveryAddress.type == 'office') {
    //     deliveryInfo += `Office ` + booking.deliveryAddress.building + `, Floor ` + booking.deliveryAddress.floor + `, Building `;
    //   }
    //   if (booking.deliveryAddress.type == 'house') {
    //     deliveryInfo += `House `;
    //   }
    //   deliveryInfo += booking.deliveryAddress.building + `, Street ` + booking.deliveryAddress.street + `
    //                       <br/>` + booking.deliveryAddress.area + ` ` + booking.deliveryAddress.block + `
    //                       <br/>Mobile Number: +` + booking.deliveryAddress.countryCode + `-` + booking.deliveryAddress.mobile + `
    //                     </p>`;
    // }
    // deliveryInfo += '</div>';
    // // END - Delivery option

    // START - Print all items the there options
    receiptItem += '<table>';
    if (booking.addons) {
      receiptItem += '<tr class="service"></tr>';
      receiptItem += `<tr class="service">
                        <td colspan="2"><h5>` + booking.courtName + " for " + booking.TimeSlot + " minutes at " + moment(booking.startTime).format('DD-MMM-YYYY hh:mm A') + `</h5></td>
                        <td><h5 class="end">` + parseFloat(this.subTotalPrice).toFixed(3) + `</h5></td>
                    </tr>`;
      booking.addons.forEach(addon => {
        receiptItem += `<tr class="service">
                                <td width="5%"><h5>` + addon.count + `</h5></td>
                                <td width="80%"><h5>` + addon.name + `(Addon)</h5></td>
                                <td width="15%"><h5 class="end">` + (addon.price * addon.count).toFixed(3) + `</h5></td>
                            </tr>`;
      });
    }
    receiptItem += '<tr><td></br></td></tr>';
    receiptItem += `<tr class="service">
                        <td colspan="2"><h5>Subtotal</h5></td>
                        <td><h5 class="end">` + parseFloat(this.subTotalPrice).toFixed(3) + `</h5></td>
                    </tr>`;
    if (this.totalDiscount > 0) {
      receiptItem += `<tr class="service">
                    <td colspan="2"><h5>Discount ` + this.totalDiscount + `%</h5></td>
                    <td><h5 class="end">-` + (this.totalDiscount / 100 * parseFloat(this.subTotalPrice)).toFixed(3) + `</h5></td>
                </tr>`;
    }
    receiptItem += `<tr class="service">
                    <td colspan="2"><h5>Addon</h5></td>
                    <td><h5 class="end">` + parseFloat(this.bookingAddon).toFixed(3) + `</h5></td>
                </tr>`;
    receiptItem += `<tr class="service">
                        <td colspan="2"><h5>Tax ` + this.taxPercentage + `%</h5></td>
                        <td><h5 class="end">` + parseFloat(this.tax).toFixed(3) + `</h5></td>
                    </tr>`;
    receiptItem += '</table>';
    // END - Print all items the there options

    // START - Total Price
    // tslint:disable-next-line:max-line-length
    total += '<h2 class="center">Total:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + booking.ccy + ' ' + parseFloat(this.f['totalPrice'].value).toFixed(3) + '</h2>';
    // END - Total Price

    // START - General Request
    // tslint:disable-next-line:max-line-length
    generalRequest += booking.specialRequest && booking.specialRequest?.trim() !== '' ? '<p>' + booking.specialRequest + newDivider + '</p>' + newDivider : '';
    // END - General Request

    // START - Cutlery
    cutlery += booking.cutleryFlag == 'Y' ? '<p>Cutlery not required</p>' + newDivider : '';
    // END - Cutlery

    // START - Tax Info
    // if (taxId) {
    //   taxInfo += `<div class="center padding-bottom">
    //                 <h5>TAX INVOICE</h5>
    //                 <h5>VAT NUMBER (` + taxId + `)</h5>
    //               </div>`
    //               + newLine;
    // }
    // END - Tax Info

    var listTransactions = [];
    var paymentInfo = '';
    this.trnData.forEach(transaction => {
      if (listTransactions.indexOf(transaction.nameEn) === -1) {
        listTransactions.push(transaction.nameEn);
      }
    });
    if (listTransactions.length > 0) {
      paymentInfo = `<h4>Paid by ` + listTransactions.join(', ') + `</h4></br>`;
    }

    // START - booking datetime
    dateTime += `<div class="center">`
      + paymentInfo +
      `<h5>` + moment().format('MMMM D, YYYY').toString() + `</h5>
                    <h5>Booked at ` + moment(booking.log_date, 'YYYY-MM-DD HH:mm:ss').format('LT').toString() + `</h5>
                    </div>`;
    // END - booking datetime


    receipt += facilityInfo
      + newLine
      + newLine
      + bookingInfo
      + newDivider
      + customerInfo
      + deliveryInfo
      + newDivider
      + cutlery
      + generalRequest
      + receiptItem
      + newDivider
      + total
      + newDivider
      + taxInfo
      + dateTime
      + thankYou
      + arenaClub
      + cutLine;

    setTimeout(() => this.printViaWeb(receipt), 500);
  }
  updateCourtOfferPrices(selectedCourtId, startTimeDT, startDateM, duration) {
    for (let offer of this.courts.offers) {
      var offerStartDate = new Date(offer.startDT.replace(/-/g, "/"));
      var offerEndDate = new Date(offer.endDT.replace(/-/g, "/"));
      //var startTimeDTMinutes = startTimeDT.getMinutes();
      //this.toolService.showConsoleLog("startTimeOriginalDT" + startTimeOriginalDT[0]);
      var endTimeDT = startDateM;
      endTimeDT.setTime(endTimeDT.getTime() + duration * 60 * 1000);
      //this.toolService.showConsoleLog("startTimeDT" + startTimeDT);


      // this.toolService.showConsoleLog("offerStartDateM" + offerStartDate);
      // this.toolService.showConsoleLog("offerEndDateM" + offerEndDate);
      // this.toolService.showConsoleLog("startDateM" + startTimeDT);
      // this.toolService.showConsoleLog("endDateM" + endTimeDT);
      // this.toolService.showConsoleLog("duration" + duration);

      //startTimeDT = moment(startTimeDT).format("HH:mm:ss");
      //endTimeDT = moment(endTimeDT).format("HH:mm:ss");

      var courtIds = offer.courtIds?.split(',');
      var reoccurDays = offer.reoccurDays?.split(',');

      if (startTimeDT >= offerStartDate && startTimeDT <= offerEndDate && courtIds.indexOf(selectedCourtId) > -1) {

        // var bookingStartTime = moment(startTimeDT);
        // var bookingEndTime = moment(endTimeDT);
        // var offerStartTime = moment(new Date(offer["startTime"].replace(/-/g, "/")));
        // var offerEndTime = moment(new Date(offer["endTime"].replace(/-/g, "/")));

        var bookingStartDate = moment(startTimeDT).format("YYYY-MM-DD");
        var offerStartTime = moment(bookingStartDate + ' ' + offer["startTimeOnly"]).format("YYYY-MM-DD HH:mm:ss");

        var bookingStartTime = moment(bookingStartDate + ' ' + moment(startTimeDT).format("HH:mm:ss")).format("YYYY-MM-DD HH:mm:ss");
        var bookingEndTime = moment(endTimeDT);

        var bookingEndDate = moment(endTimeDT).format("YYYY-MM-DD");

        if (moment(endTimeDT).format("HH:mm:ss") > moment(startTimeDT).format("HH:mm:ss")) {
          var offerEndTime = moment(bookingEndDate + ' ' + offer["endTimeOnly"]).format("YYYY-MM-DD HH:mm:ss");
        }
        else {
          var offerEndTime = moment(bookingStartDate + ' ' + offer["endTimeOnly"]).format("YYYY-MM-DD HH:mm:ss");
        }

        this.toolService.showConsoleLog("bookingStartTime" + bookingStartTime);
        this.toolService.showConsoleLog("offerStartTime" + offerStartTime);
        this.toolService.showConsoleLog("offerEndTime" + offerEndTime);

        this.selectedReoccurDay = moment(startTimeDT).format("dddd");

        if (bookingStartTime >= offerStartTime && bookingStartTime < offerEndTime && courtIds.indexOf(selectedCourtId) > -1 && reoccurDays.indexOf(this.selectedReoccurDay.toLowerCase()) > -1) {
          this.courtPrice30min = parseFloat(offer["30minPrice"]);
          this.courtPrice60min = parseFloat(offer["60minPrice"]);
          this.courtPrice90min = parseFloat(offer["90minPrice"]);
          this.courtPrice120min = parseFloat(offer["120minPrice"]);
          return;
        }
        else {
          for (let court of this.courts.content) {
            if (court.id == selectedCourtId) {
              this.courtPrice30min = parseFloat(court["30minPrice"]);
              this.courtPrice60min = parseFloat(court["60minPrice"]);
              this.courtPrice90min = parseFloat(court["90minPrice"]);
              this.courtPrice120min = parseFloat(court["120minPrice"]);
            }
          }
        }
      }
      else {
        for (let court of this.courts.content) {
          if (court.id == selectedCourtId) {
            this.courtPrice30min = parseFloat(court["30minPrice"]);
            this.courtPrice60min = parseFloat(court["60minPrice"]);
            this.courtPrice90min = parseFloat(court["90minPrice"]);
            this.courtPrice120min = parseFloat(court["120minPrice"]);
          }
        }
      }
    }
  }
  openCall(phoneNumber) {
    window.open('tel:' + phoneNumber, '_self');
  }
  openWhatsapp(phoneNumber): void {
    window.open("https://wa.me/" + phoneNumber, "_blank");
  }
  loadMatchPlayers = () => {
    return new Promise<any>(async (resolve, reject) => {
      this.localInterfaceSrv.getMatchPlayers(this.matchId)
        .then(res => {
          this.dbMatchResultsData = res;
          this.dbMatchResultsData.players = res.content;
          // this.dbMatchResultsData[0].forEach(item => {
          //   if (item.playerTeam == 'Team A')
          //   {
          //     const newObj = item;
          //     this.dbMatchResultsTeamAData.push(newObj);
          //   }
          //   else
          //   {
          //     const newObj = item;
          //     this.dbMatchResultsTeamBData.push(newObj);
          //   }
          // });
          resolve(res);
        })
        .catch(err => {
          reject(err);
          this.toolService.showConsoleLog(err)
          //this.toastr.error(err.description, "Error");
        })
        .finally();
    });
  }
  loadClassPlayers = (classId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.localInterfaceSrv.getClassPlayers(classId)
        .then(res => {
          this.dbClassResultsData = res;
          this.dbClassResultsData.players = res.content;
          this.isLoading = false;
          resolve(res);
        })
        .catch(err => {
          reject(err);
          this.toolService.showConsoleLog(err)
        })
        .finally(() => this.isLoading = false);
    });
  }

  markIsGuest(event, player) {
    if (player == "player2A") {
      if (event.target.checked) {
        this.player2ACountryCode = '0';
        this.player2AMobile = '0';
        this.f['player2AMobile'].setValue(null);
        this.f['player2ACountryCode'].disable();
        this.f['player2AMobile'].disable();
      }
      else {
        this.player2ACountryCode = this.f['player2ACountryCode'].value;
        this.player2AMobile = this.f['player2AMobile'].value;
        this.f['player2ACountryCode'].enable();
        this.f['player2AMobile'].enable();
      }
    }
    else if (player == "player1B") {
      if (event.target.checked) {
        this.player1BCountryCode = '0';
        this.player1BMobile = '0';
        this.f['player1BMobile'].setValue(null);
        this.f['player1BCountryCode'].disable();
        this.f['player1BMobile'].disable();
      }
      else {
        this.player1BCountryCode = this.f['player1BCountryCode'].value;
        this.player1BMobile = this.f['player1BMobile'].value;
        this.isPlayer1BGuest = false;
        this.f['player1BCountryCode'].enable();
        this.f['player1BMobile'].enable();
      }
    }
    else if (player == "player2B") {
      if (event.target.checked) {
        this.player2BCountryCode = '0';
        this.player2BMobile = '0';
        this.f['player2BMobile'].setValue(null);
        this.f['player2BCountryCode'].disable();
        this.f['player2BMobile'].disable();
      }
      else {
        this.player2BCountryCode = this.f['player2BCountryCode'].value;
        this.player2BMobile = this.f['player2BMobile'].value;
        this.f['player2BCountryCode'].enable();
        this.f['player2BMobile'].enable();
      }
    }
  }
  // markStatus(status) {
  //   if(status == 'open') {
  //     this.requestToJoin = false;
  //     this.isPrivateMatch = false;
  //   } else if (status == 'restricted') {
  //     this.requestToJoin = true;
  //     this.isPrivateMatch = false;
  //   } else if (status == 'private') {
  //     this.isPrivateMatch = true;
  //   }
  // }
  createMatch = () => {

    // if ((this.f['player1ACountryCode'].value == null || this.f['player1ACountryCode'].value == "null" || this.f['player1ACountryCode'].value == ""))
    // {
    //   var msg = "Player 1 Country Code is missing";
    //   this.toastr.warning(msg, "Warning");
    //   return;
    // }

    // if ((this.f['player1AMobile'].value == null || this.f['player1AMobile'].value == "null" || this.f['player1AMobile'].value == ""))
    // {
    //   var msg = "Player 1 Mobile is missing";
    //   this.toastr.warning(msg, "Warning");
    //   return;
    // }

    this.player1ACountryCode = this.f['player1ACountryCode'].value;
    this.player1AMobile = this.f['player1AMobile'].value;
    this.player2ACountryCode = this.f['player2ACountryCode'].value;
    this.player2AMobile = this.f['player2AMobile'].value;
    this.player1BCountryCode = this.f['player1BCountryCode'].value;
    this.player1BMobile = this.f['player1BMobile'].value;
    this.player2BCountryCode = this.f['player2BCountryCode'].value;
    this.player2BMobile = this.f['player2BMobile'].value;

    this.matchNotes = this.f['matchNotes'].value;

    this.toolService.showConsoleLog(this.f['radioC'].value);

    if (this.f['radioC'].value != '' && this.f['radioC'].value != null) {
      if (this.f['radioC'].value == 'open') {
        this.requestToJoin = false;
        this.isPrivateMatch = false;
      } else if (this.f['radioC'].value == 'restricted') {
        this.requestToJoin = true;
        this.isPrivateMatch = false;
      } else if (this.f['radioC'].value == 'private') {
        this.isPrivateMatch = true;
      }
    }

    if (this.f['selectMatchCategory'].value != '' && this.f['selectMatchCategory'].value != null) {
      var matchCategory = this.f['selectMatchCategory'].value;
    }

    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.createMatch(this.bookingId,
        'F',
        matchCategory,
        this.requestToJoin,
        this.isPrivateMatch,
        this.facilityId,
        '3',
        this.staffId,
        this.player1ACountryCode,
        this.player1AMobile,
        this.player2ACountryCode,
        this.player2AMobile,
        this.player1BCountryCode,
        this.player1BMobile,
        this.player2BCountryCode,
        this.player2BMobile,
        this.matchNotes)
        .then(async res => {
          resolve(res);
          this.toastr.success("Match Created", "Success");
          this.createMatchModal.hide();
          this.route.queryParams.subscribe(async params => {
            await this.loadBookingsById(this.bookingId);
            this.onSuccess();
          });
          //window.location.reload()
        })
        .catch(err => {
          reject(err);
          this.toastr.error(err.desc, "Error");
          this.createMatchModal.hide();
        })
        .finally(() => this.isLoading = false);
    });
  }
  cancelMatch = (matchId) => {

    if ((matchId == null || matchId == "null" || matchId == "")) {
      var msg = "No match to cancel, please try again";
      this.toastr.warning(msg, "Warning");
      return;
    }

    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.cancelMatch(this.staffId, matchId)
        .then(async res => {
          resolve(res);
          this.dbMatchResultsTeamAData = Array();
          this.dbMatchResultsTeamBData = Array();
          this.toastr.success("Match Cancelled", "Success");
          this.cancelMatchModal.hide();
          this.route.queryParams.subscribe(async params => {
            await this.loadBookingsById(this.bookingId);
            this.onSuccess();
          });
        })
        .catch(err => {
          reject(err);
          this.toastr.error(err.desc, "Error");
          this.cancelMatchModal.hide();
        })
        .finally(() => this.isLoading = false);
    });
  }
  createClass = () => {

    if ((this.f['noOfPlayers'].value == null || this.f['noOfPlayers'].value == "null" || this.f['noOfPlayers'].value == "")) {
      var msg = "No Of Players is missing";
      this.toastr.warning(msg, "Warning");
      return;
    }

    if ((this.f['coachId'].value == null || this.f['coachId'].value == "null" || this.f['coachId'].value == "")) {
      var msg = "Coach is missing";
      this.toastr.warning(msg, "Warning");
      return;
    }

    if ((this.f['classPrice'].value == null || this.f['classPrice'].value == "null" || this.f['classPrice'].value == "")) {
      var msg = "Class Price is missing";
      this.toastr.warning(msg, "Warning");
      return;
    }

    if ((this.f['classCcy'].value == null || this.f['classCcy'].value == "null" || this.f['classCcy'].value == "")) {
      var msg = "Class Currency is missing";
      this.toastr.warning(msg, "Warning");
      return;
    }


    this.coachId = this.f['coachId'].value;
    this.noOfPlayers = this.f['noOfPlayers'].value;
    this.classPrice = this.f['classPrice'].value;
    this.classCcy = this.f['classCcy'].value;
    this.showInApp = this.f['showInApp'].value;

    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.createClass(this.bookingId,
        this.facilityId,
        this.coachId,
        this.noOfPlayers,
        this.classPrice,
        this.classCcy,
        this.userId,
        this.showInApp)
        .then(async res => {
          resolve(res);
          this.toastr.success("Class Created", "Success");
          this.createClassModal.hide();
          this.route.queryParams.subscribe(async params => {
            await this.loadBookingsById(this.bookingId);
            this.onSuccess();
          });
          //window.location.reload()
        })
        .catch(err => {
          reject(err);
          this.toastr.error(err.desc, "Error");
          this.createClassModal.hide();
        })
        .finally(() => this.isLoading = false);
    });
  }
  cancelClass = (classId) => {

    if ((classId == null || classId == "null" || classId == "")) {
      var msg = "No class to cancel, please try again";
      this.toastr.warning(msg, "Warning");
      return;
    }

    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.cancelClass(this.staffId, classId)
        .then(async res => {
          resolve(res);
          this.dbClassResultsData = Array();
          this.toastr.success("Class Cancelled", "Success");
          this.cancelClassModal.hide();
          this.route.queryParams.subscribe(async params => {
            await this.loadBookingsById(this.bookingId);
            this.onSuccess();
          });
        })
        .catch(err => {
          reject(err);
          this.toastr.error(err.desc, "Error");
          this.cancelClassModal.hide();
        })
        .finally(() => this.isLoading = false);
    });
  }
  addClassPlayer = () => {

    this.classId = this.f['classId'].value;
    this.classPlayerMobile = this.f['classPlayerMobile'].value;
    this.classPlayerCountryCode = this.f['classPlayerCountryCode'].value;
    this.showInApp = this.f['showInApp'].value;
    this.name = this.f['name'].value;

    //this.classPlayerPaymentMethod = this.f['classPlayerPaymentMethod'].value;

    if ((this.classId == null || this.classId == "null" || this.classId == "")) {
      var msg = "No class to cancel, please try again";
      this.toastr.warning(msg, "Warning");
      return;
    }
    // if ((this.classPlayerMobile == null || this.classPlayerMobile == "null" || this.classPlayerMobile == ""))
    // {
    //   var msg = "Missing Mobile";
    //   this.toastr.warning(msg, "Warning");
    //   return;
    // }
    // if ((this.classPlayerCountryCode == null || this.classPlayerCountryCode == "null" || this.classPlayerCountryCode == ""))
    // {
    //   var msg = "Missing Country Code";
    //   this.toastr.warning(msg, "Warning");
    //   return;
    // }
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.addClassPlayer(this.staffId, this.classId, this.classPlayerMobile, this.classPlayerCountryCode, this.classPlayerPaymentMethod, this.showInApp, this.name)
        .then(async res => {
          resolve(res);
          this.dbClassResultsData = Array();
          this.toastr.success("Player added", "Success");
          this.addClassPlayerModal.hide();
          this.classPlayerMobile = '';
          this.paymentMethod = '';
          this.name = '';
          //this.f['classPlayerMobile'].patchValue(this.classPlayerMobile);
          //this.f['classPlayerCountryCode'].patchValue({classPlayerCountryCode: ''});
          this.route.queryParams.subscribe(async params => {
            await this.loadBookingsById(this.bookingId);
            this.onSuccess();
          });
        })
        .catch(err => {
          reject(err);
          this.toastr.error(err.desc, "Error");
          this.addClassPlayerModal.hide();
        })
        .finally(() => this.isLoading = false);
    });
  }
  addMatchPlayer = () => {

    this.matchPlayerMobile = this.f['matchPlayerMobile'].value;
    this.matchPlayerCountryCode = this.f['matchPlayerCountryCode'].value;
    this.name = this.f['name'].value;

    //this.matchPlayerPaymentMethod = this.f['matchPlayerPaymentMethod'].value;

    if ((this.matchId == null || this.matchId == "null" || this.matchId == "")) {
      var msg = "No match to cancel, please try again";
      this.toastr.warning(msg, "Warning");
      return;
    }
    if ((this.matchPlayerMobile == null || this.matchPlayerMobile == "null" || this.matchPlayerMobile == "")) {
      var msg = "Missing Mobile";
      this.toastr.warning(msg, "Warning");
      return;
    }
    if ((this.matchPlayerCountryCode == null || this.matchPlayerCountryCode == "null" || this.matchPlayerCountryCode == "")) {
      var msg = "Missing Country Code";
      this.toastr.warning(msg, "Warning");
      return;
    }
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.addMatchPlayer(this.staffId, this.matchId, this.matchPlayerMobile, this.matchPlayerCountryCode, this.matchPlayerPaymentMethod, this.matchPlayerTeam, this.name)
        .then(async res => {
          resolve(res);
          this.dbMatchResultsData = Array();
          this.toastr.success("Player added", "Success");
          this.addMatchPlayerModal.hide();
          this.matchPlayerMobile = '';
          this.matchPlayerPaymentMethod = '';
          this.name = '';
          //this.f['matchPlayerMobile'].patchValue(this.matchPlayerMobile);
          //this.f['matchPlayerCountryCode'].patchValue({matchPlayerCountryCode: ''});
          this.route.queryParams.subscribe(async params => {
            await this.loadBookingsById(this.bookingId);
            this.onSuccess();
          });
        })
        .catch(err => {
          reject(err);
          this.toastr.error(err.desc, "Error");
          this.addMatchPlayerModal.hide();
        })
        .finally(() => this.isLoading = false);
    });
  }
  verifyOTP = () => {

    if (this.simpleForm.controls['customerMobile'].invalid || this.simpleForm.controls['customerCountryCode'].invalid) {
      this.toastr.warning("Mobile Number is Invalid", "Warning");
      return;
    }

    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.sendVerifyOTP(this.customerCountryCode, this.customerMobile)
        .then(async res => {
          resolve(res);
          this.otpNumber = res.content;
          this.toolService.showConsoleLog(this.otpNumber);
        })
        .catch(err => {
          reject(err);
          this.toastr.error(err.desc, "Error");
        })
        .finally(() => this.isLoading = false);
    });
  }
  getCustomerInfo = () => {
    var mobile = this.f['customerMobile'].value;
    var countryCode = this.f['customerCountryCode'].value;
    if (mobile != '' && mobile != null && mobile != '0' && mobile.length >= 8 &&
      countryCode != '' && countryCode != null && countryCode != '0' && countryCode.length == 3) {
      return new Promise<any>(async (resolve, reject) => {
        this.localInterfaceSrv.getCustomerInfo(mobile, countryCode)
          .then(res => {
            if (res.content.customerName != "" && res.content.customerName != null) {
              this.f['customerName'].setValue(res.content.customerName);
              this.memberId = res.content.membershipId;
              this.membershipName = res.content.membershipName;
              this.membershipDescription = res.content.membershipDescription;
            }
            resolve(res);
          })
          .catch(err => {
            reject(err);
            this.toolService.showConsoleLog(err)
            this.toastr.error(err.desc, "Error");
          })
          .finally(() => this.isLoading = false);
      });
    }
  }
  loadBookingStatus = () => {
    var mobile = this.customerMobile;
    var countryCode = this.customerCountryCode;
    return new Promise<any>(async (resolve, reject) => {
      this.localInterfaceSrv.getBookingStatus(mobile, countryCode)
        .then(res => {
          this.toolService.showConsoleLog(res.content);
          if (res.content.pendingPayment != "" && res.content.pendingPayment != null) {
            this.toolService.showConsoleLog("res.content");
            this.toolService.showConsoleLog(res.content);
            this.pendingPayment = res.content.pendingPayment;
          }
          else {
            this.pendingPayment = '0';
          }
          resolve(res);
        })
        .catch(err => {
          reject(err);
          this.toolService.showConsoleLog(err)
          this.toastr.error(err.desc, "Error");
        })
        .finally(() => this.isLoading = false);
    });
  }

  get simpleProps() {
    const content = this.sanitize(
      '<h3 class="popover-header">' + this.membershipName + '</h3> <div class="popover-body">' + this.membershipDescription + '</div>'
    );
    return { ...this.tippyPropsDefault, content, trigger: 'mouseenter focus' };
  }
  tippyPropsDefault = {
    allowHTML: true,
    appendTo: 'parent',
    theme: 'cpopover',
    trigger: 'click',
    placement: 'right'
  };

  sanitize(value) {
    return this.sanitizer.sanitize(SecurityContext.HTML, value);
  }
}
